"use strict";

// === icons.jsx ===
// Icons (stroke, currentColor)
const Icon = ({
  size = 16,
  sw = 1.6,
  children
}) => /*#__PURE__*/React.createElement("svg", {
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: sw,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true"
}, children);
const Icons = {
  Dashboard: p => /*#__PURE__*/React.createElement(Icon, p, /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "3",
    width: "7",
    height: "9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "14",
    y: "3",
    width: "7",
    height: "5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "14",
    y: "12",
    width: "7",
    height: "9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "16",
    width: "7",
    height: "5"
  })),
  Log: p => /*#__PURE__*/React.createElement(Icon, p, /*#__PURE__*/React.createElement("line", {
    x1: "4",
    y1: "6",
    x2: "20",
    y2: "6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "4",
    y1: "12",
    x2: "20",
    y2: "12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "4",
    y1: "18",
    x2: "14",
    y2: "18"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "18",
    r: "3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "18",
    y1: "16.5",
    x2: "18",
    y2: "19.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "16.5",
    y1: "18",
    x2: "19.5",
    y2: "18"
  })),
  Factory: p => /*#__PURE__*/React.createElement(Icon, p, /*#__PURE__*/React.createElement("path", {
    d: "M2 20V9l6 4V9l6 4V5l8 4v11z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "2",
    y1: "20",
    x2: "22",
    y2: "20"
  })),
  Bolt: p => /*#__PURE__*/React.createElement(Icon, p, /*#__PURE__*/React.createElement("polygon", {
    points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2"
  })),
  Truck: p => /*#__PURE__*/React.createElement(Icon, p, /*#__PURE__*/React.createElement("rect", {
    x: "1",
    y: "7",
    width: "13",
    height: "10"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14 10 19 10 22 13 22 17 14 17 14 10"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "19",
    r: "2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "19",
    r: "2"
  })),
  Package: p => /*#__PURE__*/React.createElement(Icon, p, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.4l-9-5.19M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "3.27 6.96 12 12.01 20.73 6.96"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "12",
    y1: "22.08",
    x2: "12",
    y2: "12"
  })),
  Recycle: p => /*#__PURE__*/React.createElement(Icon, p, /*#__PURE__*/React.createElement("path", {
    d: "M7 19H4a2 2 0 0 1-2-2v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3h3a2 2 0 0 1 2 2v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 14l3-3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 8l-3 3-3-3"
  })),
  Report: p => /*#__PURE__*/React.createElement(Icon, p, /*#__PURE__*/React.createElement("path", {
    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "14 2 14 8 20 8"
  })),
  Target: p => /*#__PURE__*/React.createElement(Icon, p, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "2"
  })),
  Tips: p => /*#__PURE__*/React.createElement(Icon, p, /*#__PURE__*/React.createElement("path", {
    d: "M9 18h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 22h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2a7 7 0 0 0-4 12.7V17h8v-2.3A7 7 0 0 0 12 2z"
  })),
  Settings: p => /*#__PURE__*/React.createElement(Icon, p, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"
  })),
  Search: p => /*#__PURE__*/React.createElement(Icon, p, /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "21",
    y1: "21",
    x2: "16.65",
    y2: "16.65"
  })),
  Plus: p => /*#__PURE__*/React.createElement(Icon, p, /*#__PURE__*/React.createElement("line", {
    x1: "12",
    y1: "5",
    x2: "12",
    y2: "19"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  })),
  Download: p => /*#__PURE__*/React.createElement(Icon, p, /*#__PURE__*/React.createElement("path", {
    d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 10 12 15 17 10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "12",
    y1: "15",
    x2: "12",
    y2: "3"
  })),
  Check: p => /*#__PURE__*/React.createElement(Icon, p, /*#__PURE__*/React.createElement("polyline", {
    points: "20 6 9 17 4 12"
  })),
  Up: p => /*#__PURE__*/React.createElement(Icon, p, /*#__PURE__*/React.createElement("polyline", {
    points: "18 15 12 9 6 15"
  })),
  Down: p => /*#__PURE__*/React.createElement(Icon, p, /*#__PURE__*/React.createElement("polyline", {
    points: "6 9 12 15 18 9"
  })),
  Arrow: p => /*#__PURE__*/React.createElement(Icon, p, /*#__PURE__*/React.createElement("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 5 19 12 12 19"
  })),
  Bell: p => /*#__PURE__*/React.createElement(Icon, p, /*#__PURE__*/React.createElement("path", {
    d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"
  })),
  Fire: p => /*#__PURE__*/React.createElement(Icon, p, /*#__PURE__*/React.createElement("path", {
    d: "M8 14s.5 4 4 4 4-4 4-4-1-3-4-6c-2 2-4 4-4 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3c0 3-3 5-3 9"
  })),
  Calendar: p => /*#__PURE__*/React.createElement(Icon, p, /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "4",
    width: "18",
    height: "18",
    rx: "2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "16",
    y1: "2",
    x2: "16",
    y2: "6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "8",
    y1: "2",
    x2: "8",
    y2: "6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "3",
    y1: "10",
    x2: "21",
    y2: "10"
  }))
};
Object.assign(window, {
  Icon,
  Icons
});

// === i18n.jsx ===
// Bilingual copy dictionary (TR / EN)
const I18N = {
  tr: {
    brand_name: 'KARBON AYAK İZİ',
    brand_sub: 'Kurumsal Raporlama',
    org: 'Demirhan Tekstil A.Ş.',
    org_status: 'ISO 14064 · Doğrulandı',
    nav_main: 'Ana',
    nav_reporting: 'Raporlama',
    nav_manage: 'Yönetim',
    nav_dashboard: 'Gösterge Paneli',
    nav_log: 'Aktivite Günlüğü',
    nav_reports: 'Raporlar',
    nav_goals: 'Hedefler',
    nav_tips: 'Öneriler',
    nav_settings: 'Ayarlar',
    crumb_workspace: 'Çalışma Alanı',
    search_placeholder: 'Ara veya komut girin',
    kpi_total: 'Toplam Emisyon',
    kpi_total_sub: 'YILBAŞINDAN BERİ',
    kpi_scope1: 'Kapsam 1',
    kpi_scope1_sub: 'DOĞRUDAN',
    kpi_scope2: 'Kapsam 2',
    kpi_scope2_sub: 'ELEKTRİK',
    kpi_scope3: 'Kapsam 3',
    kpi_scope3_sub: 'TEDARİK ZİNCİRİ',
    kpi_intensity: 'Yoğunluk',
    kpi_intensity_sub: 'GELİR BAŞINA',
    kpi_target: 'Hedefe Uzaklık',
    kpi_target_sub: '2030 SBTi',
    page_title: 'Gösterge Paneli',
    page_sub: 'Q2 2026 · 42 GÜN KALDI',
    btn_log: 'Aktivite Ekle',
    btn_export: 'Dışa Aktar',
    btn_share: 'Paylaş',
    section_trend: 'Aylık Emisyon Eğilimi',
    section_trend_sub: 'Son 12 ay · tCO₂e',
    section_categories: 'Kategori Dağılımı',
    section_categories_sub: 'Bu çeyrek',
    section_facilities: 'Tesis Performansı',
    section_tips: 'Öneriler ve Uyarılar',
    section_goals: 'Azaltım Hedefleri',
    section_activity: 'Son Aktivite',
    // categories
    cat_transport: 'Ulaşım & Filo',
    cat_energy: 'Enerji Tüketimi',
    cat_supply: 'Tedarik Zinciri',
    cat_travel: 'İş Seyahatleri',
    cat_waste: 'Atık & Sular',
    cat_buildings: 'Tesisler',
    // months
    months: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
    // tips
    tip1_title: 'Filo elektrifikasyonu: %24 azaltım potansiyeli',
    tip1_body: 'Mevcut dizel filonuzun %35\'ini elektrikli modellerle değiştirmek yıllık 142 tCO₂e tasarruf sağlar.',
    tip2_title: 'Gebze tesisinde güneş paneli fırsatı',
    tip2_body: '3 MW\'lık kurulum 18 ayda geri ödemeli; yıllık 890 tCO₂e azaltım.',
    tip3_title: 'Uçuş politikası güncellemesi',
    tip3_body: 'Business sınıfı uçuşlar toplam seyahat emisyonunun %62\'sini oluşturuyor.',
    // facilities table
    tbl_facility: 'Tesis',
    tbl_type: 'Tip',
    tbl_emissions: 'tCO₂e',
    tbl_change: 'Değişim',
    tbl_status: 'Durum',
    status_ontrack: 'Hedefte',
    status_atrisk: 'Risk Altında',
    status_pending: 'Veri Bekleniyor',
    // goals
    goal_sbti_title: 'SBTi 1.5°C Hedefi',
    goal_sbti_sub: '2030\'a kadar %46 azaltım',
    goal_renewable_title: 'Yenilenebilir Elektrik',
    goal_renewable_sub: '2028\'e kadar %100',
    goal_netzero_title: 'Net Sıfır',
    goal_netzero_sub: 'Uzun vadeli · 2050',
    // log page
    log_title: 'Aktivite Ekle',
    log_sub: 'YENİ EMİSYON KAYDI',
    log_choose_cat: 'Kategori seçin',
    log_cat_fleet: 'Filo & Araçlar',
    log_cat_fleet_desc: 'Dizel, benzin, elektrikli',
    log_cat_elec: 'Elektrik',
    log_cat_elec_desc: 'Şebeke, yenilenebilir',
    log_cat_heat: 'Isıtma',
    log_cat_heat_desc: 'Doğalgaz, LPG, biyokütle',
    log_cat_travel: 'İş Seyahati',
    log_cat_travel_desc: 'Uçak, tren, otel',
    log_cat_freight: 'Taşımacılık',
    log_cat_freight_desc: 'Yük, kargo, kurye',
    log_cat_waste: 'Atık',
    log_cat_waste_desc: 'Geri dönüşüm, imha',
    log_form_date: 'Tarih',
    log_form_facility: 'Tesis',
    log_form_amount: 'Miktar',
    log_form_unit: 'Birim',
    log_form_note: 'Not',
    log_form_submit: 'Kaydet',
    log_form_cancel: 'İptal',
    log_preview: 'Tahmini Emisyon',
    log_preview_sub: 'KULLANILAN FAKTÖR',
    log_recent: 'Bu Hafta Eklenenler',
    // reports
    report_title: 'Raporlar',
    report_sub: 'GRI, CDP, SBTi UYUMLU',
    report_new: 'Yeni Rapor',
    report_name: 'Rapor Adı',
    report_period: 'Dönem',
    report_framework: 'Çerçeve',
    report_generated: 'Oluşturulma',
    // misc
    view_all: 'Tümünü gör',
    last_updated: 'Son güncelleme',
    data_sources: 'Veri kaynakları',
    tweaks_title: 'Ayarlar',
    tweaks_variant: 'Varyasyon',
    tweaks_theme: 'Tema',
    tweaks_lang: 'Dil',
    tweaks_accent: 'Renk',
    v_dense: 'Yoğun',
    v_balanced: 'Dengeli',
    v_illustrative: 'Anlatısal',
    theme_light: 'Açık',
    theme_dark: 'Koyu',
    // page subs
    log_page_sub: 'Q2 2026 · 142 KAYIT',
    reports_page_sub: '2026 · 8 RAPOR',
    goals_page_sub: '2026 · 3 AKTİF HEDEF',
    tips_page_sub: '12 ÖNERİ · 4 ACİL',
    // hero illustrative
    hero_badge: 'BU ÇEYREK',
    hero_caption: 'Karbon yoğunluğu 2019 baz yılına göre %23 azaldı. SBTi 1.5°C yolunda ilerliyorsunuz.',
    hero_since: 'Baz yıla göre',
    // additional
    report_download_all: 'Tümünü indir',
    report_columns_period: 'Dönem',
    tip_priority_high: 'Yüksek öncelik',
    tip_priority_medium: 'Orta öncelik',
    tip_impact: 'Etki',
    tip_timeline: 'Süre',
    tip_cost: 'Maliyet'
  },
  en: {
    brand_name: 'CARBON FOOTPRINT',
    brand_sub: 'Corporate Reporting',
    org: 'Demirhan Textile Co.',
    org_status: 'ISO 14064 · Verified',
    nav_main: 'Main',
    nav_reporting: 'Reporting',
    nav_manage: 'Manage',
    nav_dashboard: 'Dashboard',
    nav_log: 'Activity Log',
    nav_reports: 'Reports',
    nav_goals: 'Goals',
    nav_tips: 'Tips',
    nav_settings: 'Settings',
    crumb_workspace: 'Workspace',
    search_placeholder: 'Search or type a command',
    kpi_total: 'Total Emissions',
    kpi_total_sub: 'YEAR TO DATE',
    kpi_scope1: 'Scope 1',
    kpi_scope1_sub: 'DIRECT',
    kpi_scope2: 'Scope 2',
    kpi_scope2_sub: 'ELECTRICITY',
    kpi_scope3: 'Scope 3',
    kpi_scope3_sub: 'SUPPLY CHAIN',
    kpi_intensity: 'Intensity',
    kpi_intensity_sub: 'PER REVENUE',
    kpi_target: 'Gap to Target',
    kpi_target_sub: '2030 SBTi',
    page_title: 'Dashboard',
    page_sub: 'Q2 2026 · 42 DAYS LEFT',
    btn_log: 'Log activity',
    btn_export: 'Export',
    btn_share: 'Share',
    section_trend: 'Monthly emissions trend',
    section_trend_sub: 'Last 12 months · tCO₂e',
    section_categories: 'Category breakdown',
    section_categories_sub: 'This quarter',
    section_facilities: 'Facility performance',
    section_tips: 'Tips & alerts',
    section_goals: 'Reduction goals',
    section_activity: 'Recent activity',
    cat_transport: 'Transport & Fleet',
    cat_energy: 'Energy Use',
    cat_supply: 'Supply Chain',
    cat_travel: 'Business Travel',
    cat_waste: 'Waste & Water',
    cat_buildings: 'Facilities',
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    tip1_title: 'Fleet electrification: 24% reduction potential',
    tip1_body: 'Replacing 35% of your diesel fleet with EVs saves an estimated 142 tCO₂e/year.',
    tip2_title: 'Solar opportunity at Gebze plant',
    tip2_body: '3 MW install pays back in 18 months; 890 tCO₂e/year reduction.',
    tip3_title: 'Flight policy update',
    tip3_body: 'Business class flights contribute 62% of total travel emissions.',
    tbl_facility: 'Facility',
    tbl_type: 'Type',
    tbl_emissions: 'tCO₂e',
    tbl_change: 'Change',
    tbl_status: 'Status',
    status_ontrack: 'On track',
    status_atrisk: 'At risk',
    status_pending: 'Awaiting data',
    goal_sbti_title: 'SBTi 1.5°C target',
    goal_sbti_sub: '46% cut by 2030',
    goal_renewable_title: 'Renewable electricity',
    goal_renewable_sub: '100% by 2028',
    goal_netzero_title: 'Net zero',
    goal_netzero_sub: 'Long-term · 2050',
    log_title: 'Log activity',
    log_sub: 'NEW EMISSION RECORD',
    log_choose_cat: 'Choose category',
    log_cat_fleet: 'Fleet & vehicles',
    log_cat_fleet_desc: 'Diesel, petrol, EV',
    log_cat_elec: 'Electricity',
    log_cat_elec_desc: 'Grid, renewable',
    log_cat_heat: 'Heating',
    log_cat_heat_desc: 'Gas, LPG, biomass',
    log_cat_travel: 'Business travel',
    log_cat_travel_desc: 'Flights, rail, hotels',
    log_cat_freight: 'Freight',
    log_cat_freight_desc: 'Cargo, courier',
    log_cat_waste: 'Waste',
    log_cat_waste_desc: 'Recycling, disposal',
    log_form_date: 'Date',
    log_form_facility: 'Facility',
    log_form_amount: 'Amount',
    log_form_unit: 'Unit',
    log_form_note: 'Note',
    log_form_submit: 'Save',
    log_form_cancel: 'Cancel',
    log_preview: 'Estimated emissions',
    log_preview_sub: 'FACTOR APPLIED',
    log_recent: 'Added this week',
    report_title: 'Reports',
    report_sub: 'GRI, CDP, SBTi COMPLIANT',
    report_new: 'New report',
    report_name: 'Report name',
    report_period: 'Period',
    report_framework: 'Framework',
    report_generated: 'Generated',
    view_all: 'View all',
    last_updated: 'Last updated',
    data_sources: 'Data sources',
    tweaks_title: 'Tweaks',
    tweaks_variant: 'Variant',
    tweaks_theme: 'Theme',
    tweaks_lang: 'Language',
    tweaks_accent: 'Accent',
    v_dense: 'Dense',
    v_balanced: 'Balanced',
    v_illustrative: 'Editorial',
    theme_light: 'Light',
    theme_dark: 'Dark',
    log_page_sub: 'Q2 2026 · 142 ENTRIES',
    reports_page_sub: '2026 · 8 REPORTS',
    goals_page_sub: '2026 · 3 ACTIVE GOALS',
    tips_page_sub: '12 TIPS · 4 URGENT',
    hero_badge: 'THIS QUARTER',
    hero_caption: 'Carbon intensity down 23% versus 2019 baseline. On track for SBTi 1.5°C pathway.',
    hero_since: 'vs baseline',
    report_download_all: 'Download all',
    report_columns_period: 'Period',
    tip_priority_high: 'High priority',
    tip_priority_medium: 'Medium priority',
    tip_impact: 'Impact',
    tip_timeline: 'Timeline',
    tip_cost: 'Cost'
  }
};
Object.assign(window, {
  I18N
});

// === data.jsx ===
// Sector-agnostic demo data for Focus Academy carbon inventory tool

const COMPANY = {
  name: 'Örnek Sanayi A.Ş.',
  taxId: '1234567890',
  nace: '— Sektörünüzü seçin —',
  reportingYear: 2024,
  employees: 248,
  revenue: 480_000_000,
  productionVolume: 12_400,
  // ton
  totalArea: 32_800,
  etsScope: 'ISO 14064-1',
  etsActivity: 'Genel imalat (örnek)',
  sectors: ['İmalat', 'Gıda & İçecek', 'Kimya & Plastik', 'Tekstil', 'Metal', 'Seramik & Cam', 'Otomotiv', 'Lojistik & Nakliye', 'Hizmet', 'Perakende', 'İnşaat', 'Eğitim & Sağlık']
};
const LOCATIONS = [{
  id: 'fabrika',
  name: 'Ana Üretim Tesisi',
  type: 'Üretim',
  city: 'İstanbul',
  address: 'OSB Bölgesi',
  employees: 168,
  area: 22000,
  productionM2: 0,
  kilnCount: 0,
  established: 2008,
  etsCovered: true
}, {
  id: 'depo',
  name: 'Lojistik Depo',
  type: 'Lojistik',
  city: 'Kocaeli',
  address: 'Gebze',
  employees: 36,
  area: 8400,
  productionM2: 0,
  kilnCount: 0,
  established: 2014,
  etsCovered: false
}, {
  id: 'merkez',
  name: 'Genel Müdürlük',
  type: 'Ofis',
  city: 'İstanbul',
  address: 'Levent',
  employees: 38,
  area: 1900,
  productionM2: 0,
  kilnCount: 0,
  established: 2002,
  etsCovered: false
}, {
  id: 'sube',
  name: 'Bölge Şubesi',
  type: 'Satış',
  city: 'Ankara',
  address: 'Çankaya',
  employees: 6,
  area: 500,
  productionM2: 0,
  kilnCount: 0,
  established: 2018,
  etsCovered: false
}];

// Generic data scaled to a medium-sized SME (~10k tCO2e/yr)
const DATA_BY_YEAR = {
  2019: {
    total: 11420,
    k1: 6480,
    k2: 2240,
    k3: 1820,
    k4: 720,
    k5: 80,
    k6: 80,
    production: 12400
  },
  2020: {
    total: 9650,
    k1: 5520,
    k2: 1980,
    k3: 1480,
    k4: 580,
    k5: 60,
    k6: 30,
    production: 10100
  },
  2021: {
    total: 10380,
    k1: 5940,
    k2: 2080,
    k3: 1640,
    k4: 620,
    k5: 70,
    k6: 30,
    production: 11200
  },
  2022: {
    total: 10720,
    k1: 6120,
    k2: 2150,
    k3: 1700,
    k4: 660,
    k5: 60,
    k6: 30,
    production: 11800
  },
  2023: {
    total: 10140,
    k1: 5740,
    k2: 2080,
    k3: 1620,
    k4: 620,
    k5: 50,
    k6: 30,
    production: 11600
  },
  2024: {
    total: 9820,
    k1: 5510,
    k2: 2040,
    k3: 1580,
    k4: 610,
    k5: 50,
    k6: 30,
    production: 12100
  }
};
const CAT1_DETAIL = [{
  source: 'Doğalgaz — proses ısıtma',
  facility: 'Ana Tesis',
  activity: 2840000,
  unit: 'Sm³',
  ef: 1.95,
  efUnit: 'kgCO₂e/Sm³',
  ref: 'IPCC 2006 Vol.2',
  tier: 'Tier 2',
  tco2e: 5538,
  ets: true,
  subcat: 'Sabit yanma'
}, {
  source: 'Motorin — servis ve filo',
  facility: 'Filo',
  activity: 142000,
  unit: 'L',
  ef: 2.68,
  efUnit: 'kgCO₂e/L',
  ref: 'DEFRA 2024',
  tier: 'Tier 1',
  tco2e: 381,
  ets: false,
  subcat: 'Hareketli'
}, {
  source: 'Soğutucu gaz sızıntısı (R410A)',
  facility: 'Ana Tesis',
  activity: 18,
  unit: 'kg',
  ef: 2088,
  efUnit: 'kgCO₂e/kg',
  ref: 'IPCC AR5 GWP-100',
  tier: 'Tier 1',
  tco2e: 38,
  ets: false,
  subcat: 'Kaçak'
}, {
  source: 'Benzin — hafif ticari',
  facility: 'Filo',
  activity: 4200,
  unit: 'L',
  ef: 2.31,
  efUnit: 'kgCO₂e/L',
  ref: 'DEFRA 2024',
  tier: 'Tier 1',
  tco2e: 10,
  ets: false,
  subcat: 'Hareketli'
}, {
  source: 'LPG — yardımcı ekipman',
  facility: 'Depo',
  activity: 12000,
  unit: 'kg',
  ef: 2.94,
  efUnit: 'kgCO₂e/kg',
  ref: 'IPCC 2006',
  tier: 'Tier 1',
  tco2e: 35,
  ets: false,
  subcat: 'Sabit yanma'
}, {
  source: 'Yangın tüpleri (CO₂)',
  facility: 'Tümü',
  activity: 8,
  unit: 'kg',
  ef: 1,
  efUnit: 'kgCO₂e/kg',
  ref: 'IPCC AR5',
  tier: 'Tier 1',
  tco2e: 0.008,
  ets: false,
  subcat: 'Kaçak'
}];
const CAT2_DETAIL = [{
  source: 'Şebeke elektriği — Ana Tesis',
  facility: 'Ana Tesis',
  activity: 4200000,
  unit: 'kWh',
  ef: 0.400,
  efUnit: 'kgCO₂e/kWh',
  ref: 'TEİAŞ 2023',
  tier: 'Tier 2',
  tco2e: 1680,
  method: 'Location-based'
}, {
  source: 'Şebeke elektriği — Depo',
  facility: 'Depo',
  activity: 720000,
  unit: 'kWh',
  ef: 0.400,
  efUnit: 'kgCO₂e/kWh',
  ref: 'TEİAŞ 2023',
  tier: 'Tier 2',
  tco2e: 288,
  method: 'Location-based'
}, {
  source: 'Şebeke elektriği — GM',
  facility: 'Genel Müd.',
  activity: 165000,
  unit: 'kWh',
  ef: 0.400,
  efUnit: 'kgCO₂e/kWh',
  ref: 'TEİAŞ 2023',
  tier: 'Tier 2',
  tco2e: 66,
  method: 'Location-based'
}, {
  source: 'Şebeke elektriği — Şube',
  facility: 'Şube',
  activity: 14000,
  unit: 'kWh',
  ef: 0.400,
  efUnit: 'kgCO₂e/kWh',
  ref: 'TEİAŞ 2023',
  tier: 'Tier 2',
  tco2e: 6,
  method: 'Location-based'
}];
const CAT3_DETAIL = [{
  source: 'Ürün nakliyesi (karayolu)',
  activity: 14800000,
  unit: 'tkm',
  ef: 0.080,
  efUnit: 'kgCO₂e/tkm',
  ref: 'DEFRA 2024',
  tco2e: 1184
}, {
  source: 'Personel işe gidiş-geliş',
  activity: 1680000,
  unit: 'km',
  ef: 0.170,
  efUnit: 'kgCO₂e/km',
  ref: 'DEFRA 2024',
  tco2e: 286
}, {
  source: 'İş seyahatleri — uçak',
  activity: 48000,
  unit: 'km',
  ef: 0.200,
  efUnit: 'kgCO₂e/km',
  ref: 'DEFRA 2024',
  tco2e: 10
}, {
  source: 'Konaklama',
  activity: 380,
  unit: 'gece',
  ef: 10.8,
  efUnit: 'kgCO₂e/gece',
  ref: 'DEFRA 2024',
  tco2e: 4
}, {
  source: 'Atık nakliyesi',
  activity: 18000,
  unit: 'tkm',
  ef: 0.080,
  efUnit: 'kgCO₂e/tkm',
  ref: 'DEFRA 2024',
  tco2e: 1
}];
const CAT4_DETAIL = [{
  source: 'Hammadde — birincil malzeme',
  activity: 4800,
  unit: 'ton',
  ef: 88,
  efUnit: 'kgCO₂e/ton',
  ref: 'Ecoinvent 3.9',
  tco2e: 422
}, {
  source: 'Ambalaj — karton & palet',
  activity: 480,
  unit: 'ton',
  ef: 260,
  efUnit: 'kgCO₂e/ton',
  ref: 'DEFRA 2024',
  tco2e: 125
}, {
  source: 'Sermaye malları (amortize)',
  activity: 1,
  unit: 'dönem',
  ef: 60000,
  efUnit: 'kgCO₂e/dönem',
  ref: 'GHG Protocol',
  tco2e: 60
}];
const CAT5_DETAIL = [{
  source: 'Ürünlerin kullanım ömrü sonu (atık)',
  activity: 1840,
  unit: 'ton',
  ef: 22,
  efUnit: 'kgCO₂e/ton',
  ref: 'IPCC Waste 2019',
  tco2e: 40
}, {
  source: 'Satılan ürünlerin kullanımı',
  activity: 12100,
  unit: 'ton',
  ef: 0.85,
  efUnit: 'kgCO₂e/ton',
  ref: 'EPD ortalamaları',
  tco2e: 10
}];
const CAT6_DETAIL = [{
  source: 'Elektrik T&D kayıpları (%4.5)',
  activity: 224000,
  unit: 'kWh',
  ef: 0.400,
  efUnit: 'kgCO₂e/kWh',
  ref: 'TEİAŞ 2023',
  tco2e: 22
}, {
  source: 'Doğalgaz upstream (WTT)',
  activity: 2840000,
  unit: 'Sm³',
  ef: 0.0028,
  efUnit: 'kgCO₂e/Sm³',
  ref: 'DEFRA WTT 2024',
  tco2e: 8
}];
const CATEGORIES = [{
  num: 1,
  key: 'k1',
  title: 'Doğrudan sera gazı emisyonları',
  sub: 'Sabit + hareketli yanma, proses, sızıntı',
  color: 'var(--scope1)'
}, {
  num: 2,
  key: 'k2',
  title: 'Satın alınan enerji',
  sub: 'İthal elektrik, ısı, buhar',
  color: 'var(--scope2)'
}, {
  num: 3,
  key: 'k3',
  title: 'Nakliye ve ulaşım',
  sub: 'Girdi/çıktı nakliyesi, personel, seyahat',
  color: 'var(--scope3)'
}, {
  num: 4,
  key: 'k4',
  title: 'Satın alınan ürün ve sermaye',
  sub: 'Hammadde, ambalaj, hizmetler',
  color: 'var(--scope4)'
}, {
  num: 5,
  key: 'k5',
  title: 'Ürünlerin kullanımı',
  sub: 'Yaşam döngüsü sonu dolaylı emisyonlar',
  color: 'var(--scope5)'
}, {
  num: 6,
  key: 'k6',
  title: 'Diğer dolaylı emisyonlar',
  sub: 'T&D kayıpları, upstream yakıt, kiralık',
  color: 'var(--scope6)'
}];
const MONTHLY_2022 = [{
  m: 'Oca',
  v: 940
}, {
  m: 'Şub',
  v: 880
}, {
  m: 'Mar',
  v: 920
}, {
  m: 'Nis',
  v: 890
}, {
  m: 'May',
  v: 870
}, {
  m: 'Haz',
  v: 820
}, {
  m: 'Tem',
  v: 760
}, {
  m: 'Ağu',
  v: 780
}, {
  m: 'Eyl',
  v: 840
}, {
  m: 'Eki',
  v: 870
}, {
  m: 'Kas',
  v: 900
}, {
  m: 'Ara',
  v: 950
}];
const ETS = {
  scope: ['Doğalgaz yanması', 'Diğer sabit yakıtlar', 'LPG yardımcı', 'Proses CO₂'],
  verified: 5573,
  freeAllocation: 4800,
  purchasedAllowances: 0,
  surrenderRequired: 5573,
  balance: -773,
  price2022: 82,
  price2024: 72,
  price2025: 78,
  price2026: 85,
  benchmarkEF: 0.45,
  intensity: 5573 / 12400 * 1000,
  cbamAt: 'Elektrik + proses (ihracat için)',
  carbonLeakageStatus: 'Sektöre göre değişir',
  penaltyRate: 100,
  nextDeadline: '30.04.2026'
};
const ETS_SCENARIOS = [{
  year: 2022,
  allocation: 4800,
  emissions: 6120,
  price: 82
}, {
  year: 2023,
  allocation: 4594,
  emissions: 5740,
  price: 85
}, {
  year: 2024,
  allocation: 4396,
  emissions: 5510,
  price: 72
}, {
  year: 2025,
  allocation: 4207,
  emissions: 5300,
  price: 78
}, {
  year: 2026,
  allocation: 4026,
  emissions: 5100,
  price: 85
}, {
  year: 2027,
  allocation: 3853,
  emissions: 4900,
  price: 92
}, {
  year: 2028,
  allocation: 3687,
  emissions: 4700,
  price: 100
}, {
  year: 2029,
  allocation: 3529,
  emissions: 4500,
  price: 108
}, {
  year: 2030,
  allocation: 3377,
  emissions: 4300,
  price: 115
}];
const RECENT_ENTRIES = [{
  date: '19.04.2026',
  user: 'Demo Kullanıcı',
  category: 'K1 · Doğalgaz',
  facility: 'Ana Tesis',
  value: 248000,
  unit: 'Sm³',
  co2e: 484,
  status: 'ok'
}, {
  date: '18.04.2026',
  user: 'Sistem',
  category: 'K2 · Elektrik',
  facility: 'Tüm tesisler',
  value: 425000,
  unit: 'kWh',
  co2e: 170,
  status: 'ok'
}, {
  date: '18.04.2026',
  user: 'Demo Kullanıcı',
  category: 'K3 · Nakliye',
  facility: 'Sevkiyat',
  value: 142000,
  unit: 'tkm',
  co2e: 11.4,
  status: 'ok'
}, {
  date: '17.04.2026',
  user: 'Demo Kullanıcı',
  category: 'K1 · Motorin',
  facility: 'Filo',
  value: 11500,
  unit: 'L',
  co2e: 31,
  status: 'ok'
}, {
  date: '16.04.2026',
  user: 'Sistem',
  category: 'K4 · Hammadde',
  facility: 'Satınalma',
  value: 1,
  unit: 'dönem',
  co2e: 80,
  status: 'pending'
}];
const FACILITIES = [{
  name: 'Ana Üretim Tesisi',
  type: 'Üretim',
  k1: 4860,
  k2: 1680,
  k3: 980,
  k4: 420,
  status: 'ok'
}, {
  name: 'Lojistik Depo',
  type: 'Lojistik',
  k1: 380,
  k2: 288,
  k3: 540,
  k4: 130,
  status: 'warn'
}, {
  name: 'Genel Müdürlük',
  type: 'Ofis',
  k1: 245,
  k2: 66,
  k3: 48,
  k4: 50,
  status: 'ok'
}, {
  name: 'Bölge Şubesi',
  type: 'Satış',
  k1: 25,
  k2: 6,
  k3: 12,
  k4: 10,
  status: 'ok'
}];
const REPORTS = [{
  name: 'ISO 14064-1 Sera Gazı Envanteri',
  framework: 'ISO 14064-1',
  period: '2024',
  generated: '15.03.2025',
  status: 'Taslak'
}, {
  name: 'CDP Climate Change Yanıtı',
  framework: 'CDP',
  period: 'FY 2024',
  generated: '10.06.2025',
  status: 'Hazırlık'
}, {
  name: 'GRI 305 Emisyon Açıklaması',
  framework: 'GRI',
  period: '2024',
  generated: '28.04.2025',
  status: 'Taslak'
}, {
  name: 'SBTi Hedef Başvurusu',
  framework: 'SBTi',
  period: '2024-2030',
  generated: '—',
  status: 'Plan'
}, {
  name: 'CBAM Çeyreklik Rapor',
  framework: 'CBAM',
  period: 'Q1 2026',
  generated: '—',
  status: 'Plan'
}];
const TIPS = [{
  title: 'YEK-G yenilenebilir elektrik tedariki',
  body: 'Market-based yöntemde Kategori 2 büyük ölçüde sıfırlanabilir: yıllık ~2.000 tCO₂e düşüş. kWh başına ~0,08 TL prim. Hızlı, düşük maliyetli kaldıraç.',
  impact: '~2.000 tCO₂e',
  cost: '₺',
  time: '3 ay',
  priority: 'high'
}, {
  title: 'Isı geri kazanım sistemleri',
  body: 'Baca/atık gazlardan ısı geri kazanımı doğalgaz tüketimini %8-12 azaltabilir. Operasyonel ve geri ödemesi hızlı.',
  impact: '~550 tCO₂e',
  cost: '₺₺₺',
  time: '18-24 ay',
  priority: 'high'
}, {
  title: 'Filo elektrifikasyonu',
  body: 'Servis ve hafif ticari araçları kademeli olarak elektrikli/hibrit modellere geçirin. K1 motorin emisyonunu %60+ azaltır.',
  impact: '~230 tCO₂e',
  cost: '₺₺',
  time: '12-36 ay',
  priority: 'medium'
}, {
  title: 'Tedarik zinciri optimizasyonu',
  body: 'Konsolide sevkiyat ve tam yük operasyonu K3 nakliyesini %15-20 düşürür. Yazılım yatırımı + süreç tasarımı.',
  impact: '~240 tCO₂e',
  cost: '₺',
  time: '3-6 ay',
  priority: 'high'
}, {
  title: 'ISO 14064-1 envanteri belgelendirme',
  body: 'Bağımsız doğrulama envanterinizi tedarik zinciri talepleri ve CBAM/CDP raporlaması için daha güvenilir bir temele oturtur.',
  impact: 'Uygunluk',
  cost: '₺₺',
  time: '6-9 ay',
  priority: 'high'
}, {
  title: 'SBTi 1.5°C hedef başvurusu',
  body: '2030 mutlak azaltım hedefi belirleyin, bilim temelli olarak doğrulatın. Yatırımcı ve müşteri talebi.',
  impact: 'Strateji',
  cost: '₺',
  time: '6 ay',
  priority: 'medium'
}];
Object.assign(window, {
  COMPANY,
  LOCATIONS,
  DATA_BY_YEAR,
  CAT1_DETAIL,
  CAT2_DETAIL,
  CAT3_DETAIL,
  CAT4_DETAIL,
  CAT5_DETAIL,
  CAT6_DETAIL,
  CATEGORIES,
  MONTHLY_2022,
  ETS,
  ETS_SCENARIOS,
  RECENT_ENTRIES,
  FACILITIES,
  REPORTS,
  TIPS
});
window.CAT1_2022 = CAT1_DETAIL.map(r => ({
  label: r.source,
  value: r.tco2e,
  color: '#1f8a5b'
}));
window.CAT3_2022 = CAT3_DETAIL.map(r => ({
  label: r.source,
  value: r.tco2e
}));

// === charts.jsx ===
// Chart primitives

function Sparkline({
  data,
  color = 'var(--clay)',
  height = 28,
  fill = true
}) {
  const max = Math.max(...data),
    min = Math.min(...data),
    range = max - min || 1;
  const w = 120;
  const pts = data.map((v, i) => {
    const x = i / (data.length - 1) * w;
    const y = height - (v - min) / range * (height - 4) - 2;
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  });
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: height,
    viewBox: `0 0 ${w} ${height}`,
    preserveAspectRatio: "none",
    className: "spark"
  }, fill && /*#__PURE__*/React.createElement("path", {
    d: `M 0,${height} L ${pts.join(' L ')} L ${w},${height} Z`,
    fill: color,
    opacity: "0.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: `M ${pts.join(' L ')}`,
    fill: "none",
    stroke: color,
    strokeWidth: "1.5",
    strokeLinejoin: "round",
    vectorEffect: "non-scaling-stroke"
  }));
}
function StackedYearBars({
  years,
  height = 260
}) {
  const data = years.map(y => ({
    y,
    ...DATA_BY_YEAR[y]
  }));
  const max = Math.max(...data.map(d => d.total)) * 1.05;
  const keys = ['k1', 'k2', 'k3', 'k4', 'k5', 'k6'];
  const colors = ['var(--scope1)', 'var(--scope2)', 'var(--scope3)', 'var(--scope4)', 'var(--scope5)', 'var(--scope6)'];
  return /*#__PURE__*/React.createElement("div", {
    className: "chart-grid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bars",
    style: {
      height,
      gridTemplateColumns: `repeat(${data.length}, 1fr)`
    }
  }, data.map((d, di) => /*#__PURE__*/React.createElement("div", {
    key: d.y,
    className: "bar-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "stack-col",
    style: {
      width: '70%',
      margin: '0 auto',
      height: `${d.total / max * 100}%`
    }
  }, keys.map((k, i) => /*#__PURE__*/React.createElement("span", {
    key: k,
    style: {
      background: colors[i],
      height: `${d[k] / d.total * 100}%`
    },
    title: `K${i + 1}: ${Math.round(d[k]).toLocaleString()}`
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      bottom: `${d.total / max * 100}%`,
      left: 0,
      right: 0,
      textAlign: 'center',
      transform: 'translateY(-18px)',
      fontFamily: 'var(--mono)',
      fontSize: 11,
      color: 'var(--ink-2)',
      fontWeight: 500
    }
  }, Math.round(d.total / 1000), "k")))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: `repeat(${data.length}, 1fr)`,
      gap: 6,
      marginTop: 8
    }
  }, data.map(d => /*#__PURE__*/React.createElement("div", {
    key: d.y,
    className: "bar-label"
  }, d.y))));
}
function MonthBars({
  data,
  height = 180
}) {
  const max = Math.max(...data.map(d => d.v)) * 1.1;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "bars",
    style: {
      height,
      gridTemplateColumns: `repeat(${data.length}, 1fr)`
    }
  }, data.map((d, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: "bar-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bar",
    style: {
      height: `${d.v / max * 100}%`,
      background: 'var(--clay)'
    },
    title: `${d.v.toLocaleString()} tCO₂e`
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: `repeat(${data.length}, 1fr)`,
      gap: 6,
      marginTop: 8
    }
  }, data.map((d, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: "bar-label"
  }, d.m))));
}
function DonutBreakdown({
  data,
  size = 220,
  stroke = 30
}) {
  const total = data.reduce((s, d) => s + d.value, 0);
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  let acc = 0;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: `0 0 ${size} ${size}`
  }, /*#__PURE__*/React.createElement("circle", {
    cx: size / 2,
    cy: size / 2,
    r: r,
    fill: "none",
    stroke: "var(--line-2)",
    strokeWidth: stroke
  }), data.map((d, i) => {
    const frac = d.value / total;
    const dash = frac * c;
    const offset = -acc * c;
    acc += frac;
    return /*#__PURE__*/React.createElement("circle", {
      key: i,
      cx: size / 2,
      cy: size / 2,
      r: r,
      fill: "none",
      stroke: d.color,
      strokeWidth: stroke,
      strokeDasharray: `${dash} ${c - dash}`,
      strokeDashoffset: offset,
      transform: `rotate(-90 ${size / 2} ${size / 2})`
    });
  }), /*#__PURE__*/React.createElement("text", {
    x: size / 2,
    y: size / 2 - 4,
    textAnchor: "middle",
    fontFamily: "var(--mono)",
    fontSize: "11",
    fill: "var(--ink-3)",
    style: {
      textTransform: 'uppercase',
      letterSpacing: '0.08em'
    }
  }, "TOPLAM"), /*#__PURE__*/React.createElement("text", {
    x: size / 2,
    y: size / 2 + 20,
    textAnchor: "middle",
    fontFamily: "var(--mono)",
    fontSize: "22",
    fill: "var(--ink)",
    fontWeight: "500"
  }, Math.round(total / 1000), "k"));
}
function HBar({
  data,
  maxValue,
  height = 18
}) {
  const max = maxValue || Math.max(...data.map(d => d.value));
  return /*#__PURE__*/React.createElement("div", {
    className: "col",
    style: {
      gap: 10
    }
  }, data.map((d, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 80px',
      gap: 12,
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12,
      marginBottom: 4,
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React.createElement("span", null, d.label)), /*#__PURE__*/React.createElement("div", {
    style: {
      height: 6,
      background: 'var(--line-2)',
      borderRadius: 2,
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: '100%',
      width: `${d.value / max * 100}%`,
      background: d.color || 'var(--clay)'
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "num",
    style: {
      textAlign: 'right',
      fontSize: 12,
      color: 'var(--ink-2)'
    }
  }, d.value.toLocaleString('tr-TR', {
    maximumFractionDigits: 0
  })))));
}
Object.assign(window, {
  Sparkline,
  StackedYearBars,
  MonthBars,
  DonutBreakdown,
  HBar
});

// === browser-window.jsx ===

// Chrome.jsx — Simplified Chrome browser window (dark theme, macOS)
// No dependencies, no image assets. All inline styles + inline SVG.

const CHROME_C = {
  barBg: '#202124',
  tabBg: '#35363a',
  text: '#e8eaed',
  dim: '#9aa0a6',
  urlBg: '#282a2d'
};
function ChromeTrafficLights() {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 8,
      padding: '0 14px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 12,
      height: 12,
      borderRadius: '50%',
      background: '#ff5f57'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: 12,
      height: 12,
      borderRadius: '50%',
      background: '#febc2e'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: 12,
      height: 12,
      borderRadius: '50%',
      background: '#28c840'
    }
  }));
}

// Single tab (active has curved scoops)
function ChromeTab({
  title = 'New Tab',
  active = false
}) {
  const curve = flip => /*#__PURE__*/React.createElement("svg", {
    width: "8",
    height: "10",
    viewBox: "0 0 8 10",
    style: {
      position: 'absolute',
      bottom: 0,
      [flip ? 'right' : 'left']: -8,
      transform: flip ? 'scaleX(-1)' : 'none'
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C2 9 6 8 8 0V10H0Z",
    fill: CHROME_C.tabBg
  }));
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      height: 34,
      alignSelf: 'flex-end',
      padding: '0 12px',
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      background: active ? CHROME_C.tabBg : 'transparent',
      borderRadius: '8px 8px 0 0',
      minWidth: 120,
      maxWidth: 220,
      fontFamily: 'system-ui, sans-serif',
      fontSize: 12,
      color: active ? CHROME_C.text : CHROME_C.dim
    }
  }, active && curve(false), active && curve(true), /*#__PURE__*/React.createElement("div", {
    style: {
      width: 14,
      height: 14,
      borderRadius: '50%',
      background: '#5f6368',
      flexShrink: 0
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      flex: 1,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  }, title));
}
function ChromeTabBar({
  tabs = [{
    title: 'New Tab'
  }],
  activeIndex = 0
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      height: 44,
      background: CHROME_C.barBg,
      paddingRight: 8
    }
  }, /*#__PURE__*/React.createElement(ChromeTrafficLights, null), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'flex-end',
      height: '100%',
      paddingLeft: 4,
      flex: 1
    }
  }, tabs.map((t, i) => /*#__PURE__*/React.createElement(ChromeTab, {
    key: i,
    title: t.title,
    active: i === activeIndex
  }))));
}
function ChromeToolbar({
  url = 'example.com'
}) {
  const iconDot = /*#__PURE__*/React.createElement("div", {
    style: {
      width: 28,
      height: 28,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 16,
      height: 16,
      borderRadius: '50%',
      background: CHROME_C.dim,
      opacity: 0.4
    }
  }));
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: 40,
      background: CHROME_C.tabBg,
      display: 'flex',
      alignItems: 'center',
      gap: 4,
      padding: '0 8px'
    }
  }, iconDot, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      height: 30,
      borderRadius: 15,
      background: CHROME_C.urlBg,
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      padding: '0 14px',
      margin: '0 6px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 12,
      height: 12,
      borderRadius: '50%',
      background: CHROME_C.dim,
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      flex: 1,
      color: CHROME_C.text,
      fontSize: 13,
      fontFamily: 'system-ui, sans-serif'
    }
  }, url)), iconDot);
}
function ChromeWindow({
  tabs = [{
    title: 'New Tab'
  }],
  activeIndex = 0,
  url = 'example.com',
  width = 900,
  height = 600,
  children
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width,
      height,
      borderRadius: 10,
      overflow: 'hidden',
      boxShadow: '0 24px 80px rgba(0,0,0,0.35), 0 0 0 1px rgba(0,0,0,0.1)',
      display: 'flex',
      flexDirection: 'column',
      background: CHROME_C.tabBg
    }
  }, /*#__PURE__*/React.createElement(ChromeTabBar, {
    tabs: tabs,
    activeIndex: activeIndex
  }), /*#__PURE__*/React.createElement(ChromeToolbar, {
    url: url
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      background: '#fff',
      overflow: 'auto'
    }
  }, children));
}
Object.assign(window, {
  ChromeWindow,
  ChromeTabBar,
  ChromeToolbar,
  ChromeTab,
  ChromeTrafficLights
});

// === chrome.jsx ===
// Sidebar + Topbar — Focus Academy branding

function Sidebar({
  page,
  setPage,
  year,
  setYear,
  onContact,
  onHome
}) {
  const Item = ({
    id,
    label,
    idx,
    count,
    locked
  }) => /*#__PURE__*/React.createElement("button", {
    className: `nav-item ${page === id ? 'active' : ''}`,
    onClick: () => setPage(id)
  }, /*#__PURE__*/React.createElement("span", {
    className: "idx"
  }, idx), /*#__PURE__*/React.createElement("span", null, label), locked && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 11,
      opacity: 0.6
    }
  }, "\uD83D\uDD12"), count != null && /*#__PURE__*/React.createElement("span", {
    className: "count"
  }, count));
  const catsOpen = page === 'scopes' || page.startsWith('cat-');
  const catTotals = DATA_BY_YEAR[year];
  return /*#__PURE__*/React.createElement("aside", {
    className: "sidebar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "brand",
    onClick: onHome,
    style: {
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "brand-mark"
  }, "F"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "brand-name"
  }, "FOCUS ACADEMY"), /*#__PURE__*/React.createElement("div", {
    className: "brand-sub"
  }, "Karbon Envanteri"))), /*#__PURE__*/React.createElement("div", {
    className: "year-switcher"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row1"
  }, /*#__PURE__*/React.createElement("span", null, "Raporlama Y\u0131l\u0131"), /*#__PURE__*/React.createElement("span", null, "ISO 14064-1")), /*#__PURE__*/React.createElement("div", {
    className: "year-tabs"
  }, [2022, 2023, 2024].map(y => /*#__PURE__*/React.createElement("button", {
    key: y,
    className: year === y ? 'on' : '',
    onClick: () => setYear(y)
  }, y)))), /*#__PURE__*/React.createElement("div", {
    className: "nav-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "nav-label"
  }, "Envanter"), /*#__PURE__*/React.createElement(Item, {
    id: "dashboard",
    label: "G\xF6sterge paneli",
    idx: "01"
  }), /*#__PURE__*/React.createElement(Item, {
    id: "entry",
    label: "Veri giri\u015Fi",
    idx: "02"
  }), /*#__PURE__*/React.createElement(Item, {
    id: "scopes",
    label: "Kategori analizi",
    idx: "03"
  }), catsOpen && CATEGORIES.map(c => /*#__PURE__*/React.createElement("button", {
    key: c.key,
    className: `nav-item nested ${page === `cat-${c.num}` ? 'active' : ''}`,
    onClick: () => setPage(`cat-${c.num}`)
  }, /*#__PURE__*/React.createElement("span", {
    className: "cat-dot",
    style: {
      background: c.color
    }
  }), /*#__PURE__*/React.createElement("span", null, "K", c.num, " \u2014 ", c.title.split(' ').slice(0, 2).join(' ')), /*#__PURE__*/React.createElement("span", {
    className: "count mono",
    style: {
      fontSize: 10
    }
  }, Math.round(catTotals[c.key] / 1000), "k"))), /*#__PURE__*/React.createElement(Item, {
    id: "ets",
    label: "ETS Sonu\xE7",
    idx: "04",
    locked: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "nav-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "nav-label"
  }, "Raporlama (Premium)"), /*#__PURE__*/React.createElement(Item, {
    id: "reports",
    label: "Raporlar",
    idx: "05",
    locked: true
  }), /*#__PURE__*/React.createElement(Item, {
    id: "goals",
    label: "Hedefler",
    idx: "06",
    locked: true
  }), /*#__PURE__*/React.createElement(Item, {
    id: "tips",
    label: "\xD6neriler",
    idx: "07",
    locked: true
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "fa-promo"
  }, /*#__PURE__*/React.createElement("h5", null, "Hesap kolay, y\xF6netim zor."), /*#__PURE__*/React.createElement("p", null, "Do\u011Frulama, raporlama, azalt\u0131m \u2014 Focus Academy i\u015Fletmelere 20 y\u0131l\u0131 a\u015Fk\u0131n deneyimle e\u015Flik ediyor. 10 dakikal\u0131k \xFCcretsiz \xF6n g\xF6r\xFC\u015Fme."), /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: e => {
      e.preventDefault();
      onContact && onContact();
    }
  }, "Bize ula\u015F\u0131n \u2192")), /*#__PURE__*/React.createElement("div", {
    className: "sidebar-foot"
  }, /*#__PURE__*/React.createElement("div", null, "FOCUS ACADEMY \xB7 Belgelendirme & S\xFCrd\xFCr\xFClebilirlik"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    href: "https://www.focusacademy.com.tr",
    target: "_blank",
    rel: "noopener",
    style: {
      color: 'inherit',
      textDecoration: 'none'
    }
  }, "www.focusacademy.com.tr"))));
}
function Topbar({
  pageTitle,
  year,
  onContact
}) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "fa-topbanner"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("strong", null, "Focus Academy"), " \u2014 ISO 14064-1 \xB7 CBAM \xB7 SBTi dan\u0131\u015Fmanl\u0131k. \u0130lk g\xF6r\xFC\u015Fme \xFCcretsiz."), /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: e => {
      e.preventDefault();
      onContact && onContact();
    }
  }, "\u0130leti\u015Fim \u2192")), /*#__PURE__*/React.createElement("div", {
    className: "fa-demo-banner"
  }, /*#__PURE__*/React.createElement("span", null, "\uD83D\uDCCA ", /*#__PURE__*/React.createElement("strong", null, "\xD6rnek firma verisiyle \xE7al\u0131\u015F\u0131yorsunuz"), " \u2014 kurgusal 2022-2024 d\xF6nemi. De\u011Ferleri kendi \u015Firketinize g\xF6re d\xFCzenleyebilirsiniz.")), /*#__PURE__*/React.createElement("div", {
    className: "topbar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "crumb"
  }, /*#__PURE__*/React.createElement("span", null, "Focus Academy"), /*#__PURE__*/React.createElement("span", {
    className: "sep"
  }, "/"), /*#__PURE__*/React.createElement("span", null, year), /*#__PURE__*/React.createElement("span", {
    className: "sep"
  }, "/"), /*#__PURE__*/React.createElement("span", {
    className: "now"
  }, pageTitle)), /*#__PURE__*/React.createElement("div", {
    className: "topbar-spacer"
  }), /*#__PURE__*/React.createElement("div", {
    className: "status-chip"
  }, /*#__PURE__*/React.createElement("span", {
    className: "dot"
  }), "Hesaplama Aktif"), /*#__PURE__*/React.createElement("button", {
    className: "icon-btn"
  }, /*#__PURE__*/React.createElement(Icons.Search, {
    size: 15
  })), /*#__PURE__*/React.createElement("button", {
    className: "icon-btn"
  }, /*#__PURE__*/React.createElement(Icons.Bell, {
    size: 15
  })), /*#__PURE__*/React.createElement("div", {
    className: "avatar"
  }, "FA")));
}
Object.assign(window, {
  Sidebar,
  Topbar
});

// === log.jsx ===
// Log page — Activity logging form with category picker

function LogPage({
  t
}) {
  const [cat, setCat] = React.useState('fleet');
  const [amount, setAmount] = React.useState('4200');
  const [unit, setUnit] = React.useState('kWh');
  const cats = [{
    key: 'fleet',
    icon: 'Car',
    factor: '0.41 kgCO₂e/km',
    defaultUnit: 'km'
  }, {
    key: 'elec',
    icon: 'Bolt',
    factor: '0.40 kgCO₂e/kWh',
    defaultUnit: 'kWh'
  }, {
    key: 'heat',
    icon: 'Home',
    factor: '2.03 kgCO₂e/m³',
    defaultUnit: 'm³'
  }, {
    key: 'travel',
    icon: 'Plane',
    factor: '0.18 kgCO₂e/km',
    defaultUnit: 'km'
  }, {
    key: 'freight',
    icon: 'Factory',
    factor: '0.08 kgCO₂e/tkm',
    defaultUnit: 'tkm'
  }, {
    key: 'waste',
    icon: 'Leaf',
    factor: '0.21 kgCO₂e/kg',
    defaultUnit: 'kg'
  }];
  const active = cats.find(c => c.key === cat);
  const estimate = (Number(amount) || 0) * parseFloat(active.factor) / 1000;
  return /*#__PURE__*/React.createElement("div", {
    className: "page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
    className: "page-title"
  }, t.log_title), /*#__PURE__*/React.createElement("div", {
    className: "page-sub"
  }, t.log_page_sub))), /*#__PURE__*/React.createElement("div", {
    className: "log-grid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, t.log_choose_cat), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, t.log_sub))), /*#__PURE__*/React.createElement("div", {
    className: "log-categories"
  }, cats.map(c => /*#__PURE__*/React.createElement("button", {
    key: c.key,
    className: `log-cat-btn ${cat === c.key ? 'selected' : ''}`,
    onClick: () => {
      setCat(c.key);
      setUnit(c.defaultUnit);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: {
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "cat-icon",
    style: {
      background: cat === c.key ? 'var(--green-700)' : 'var(--green-100)',
      color: cat === c.key ? '#eaf2ea' : 'var(--green-700)'
    }
  }, React.createElement(Icons[c.icon], {
    size: 15
  })), cat === c.key && /*#__PURE__*/React.createElement(Icons.Check, {
    size: 14
  })), /*#__PURE__*/React.createElement("div", {
    className: "log-cat-name"
  }, t[`log_cat_${c.key}`]), /*#__PURE__*/React.createElement("div", {
    className: "log-cat-desc"
  }, t[`log_cat_${c.key}_desc`])))), /*#__PURE__*/React.createElement("div", {
    style: {
      borderTop: '1px solid var(--line)',
      marginTop: 20,
      paddingTop: 20,
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement("label", null, t.log_form_date), /*#__PURE__*/React.createElement("input", {
    type: "date",
    defaultValue: "2026-04-19"
  })), /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement("label", null, t.log_form_facility), /*#__PURE__*/React.createElement("select", {
    defaultValue: "gebze-01"
  }, /*#__PURE__*/React.createElement("option", {
    value: "gebze-01"
  }, "Gebze Plant 01"), /*#__PURE__*/React.createElement("option", {
    value: "gebze-02"
  }, "Gebze Plant 02"), /*#__PURE__*/React.createElement("option", {
    value: "izmir"
  }, "\u0130zmir Distribution"), /*#__PURE__*/React.createElement("option", {
    value: "istanbul"
  }, "\u0130stanbul HQ"), /*#__PURE__*/React.createElement("option", {
    value: "ankara"
  }, "Ankara Showroom"))), /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement("label", null, t.log_form_amount), /*#__PURE__*/React.createElement("input", {
    value: amount,
    onChange: e => setAmount(e.target.value),
    className: "num"
  })), /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement("label", null, t.log_form_unit), /*#__PURE__*/React.createElement("select", {
    value: unit,
    onChange: e => setUnit(e.target.value)
  }, /*#__PURE__*/React.createElement("option", null, "kWh"), /*#__PURE__*/React.createElement("option", null, "km"), /*#__PURE__*/React.createElement("option", null, "m\xB3"), /*#__PURE__*/React.createElement("option", null, "kg"), /*#__PURE__*/React.createElement("option", null, "tkm"), /*#__PURE__*/React.createElement("option", null, "L"))), /*#__PURE__*/React.createElement("div", {
    className: "form-row",
    style: {
      gridColumn: 'span 2'
    }
  }, /*#__PURE__*/React.createElement("label", null, t.log_form_note), /*#__PURE__*/React.createElement("input", {
    placeholder: "Optional \u2014 invoice #, source, reference..."
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: {
      justifyContent: 'flex-end',
      gap: 8,
      marginTop: 20
    }
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn"
  }, t.log_form_cancel), /*#__PURE__*/React.createElement("button", {
    className: "btn primary"
  }, /*#__PURE__*/React.createElement(Icons.Check, {
    size: 14
  }), t.log_form_submit))), /*#__PURE__*/React.createElement("div", {
    className: "col",
    style: {
      gap: 16
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card",
    style: {
      background: 'var(--green-700)',
      color: '#eaf2ea',
      borderColor: 'var(--green-700)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 11,
      fontFamily: 'var(--mono)',
      opacity: 0.7,
      textTransform: 'uppercase',
      letterSpacing: '0.08em'
    }
  }, t.log_preview), /*#__PURE__*/React.createElement("div", {
    className: "num",
    style: {
      fontSize: 48,
      fontWeight: 500,
      letterSpacing: '-0.03em',
      marginTop: 6,
      lineHeight: 1.1
    }
  }, estimate.toFixed(2), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 18,
      opacity: 0.7,
      marginLeft: 6
    }
  }, "tCO\u2082e")), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 14,
      paddingTop: 14,
      borderTop: '1px solid rgba(234,242,234,0.15)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 10.5,
      fontFamily: 'var(--mono)',
      opacity: 0.6,
      textTransform: 'uppercase',
      letterSpacing: '0.08em'
    }
  }, t.log_preview_sub), /*#__PURE__*/React.createElement("div", {
    className: "num",
    style: {
      fontSize: 14,
      marginTop: 4
    }
  }, active.factor), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 11.5,
      opacity: 0.65,
      marginTop: 4
    }
  }, "DEFRA 2024 \xB7 TR grid mix"))), /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, t.log_recent), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, "18 entries"))), /*#__PURE__*/React.createElement("div", {
    className: "col",
    style: {
      gap: 12
    }
  }, RECENT_ACTIVITY.slice(0, 5).map((a, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: "row",
    style: {
      justifyContent: 'space-between',
      fontSize: 12.5,
      paddingBottom: 12,
      borderBottom: i < 4 ? '1px solid var(--line-2)' : 'none'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 500
    }
  }, a.what), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 11.5,
      color: 'var(--ink-3)',
      fontFamily: 'var(--mono)',
      marginTop: 2
    }
  }, a.facility, " \xB7 ", a.time)), /*#__PURE__*/React.createElement("div", {
    className: "num",
    style: {
      fontWeight: 500
    }
  }, a.value.toFixed(2), " t"))))))));
}
Object.assign(window, {
  LogPage
});

// === entry.jsx ===
// Extended data entry form + per-category analysis + ETS pages

// CSV indirme yardımcısı (Excel uyumlu: ; ayraç + UTF-8 BOM)
function faDownloadCSV(filename, rows) {
  const csv = rows.map(r => r.map(c => '"' + String(c == null ? '' : c).replace(/"/g, '""') + '"').join(';')).join('\r\n');
  const blob = new Blob(['﻿' + csv], {
    type: 'text/csv;charset=utf-8;'
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    try {
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (e) {}
  }, 120);
}
function DataEntry({
  year
}) {
  const [tab, setTab] = React.useState('company');
  const [toast, setToast] = React.useState('');
  const bodyRef = React.useRef(null);
  const tabs = [{
    id: 'company',
    label: 'Şirket Bilgileri',
    idx: '01'
  }, {
    id: 'locations',
    label: 'Lokasyonlar',
    idx: '02'
  }, {
    id: 'employees',
    label: 'Çalışan & Ulaşım',
    idx: '03'
  }, {
    id: 'production',
    label: 'Üretim Verileri',
    idx: '04'
  }, {
    id: 'energy',
    label: 'Enerji Tüketimi',
    idx: '05'
  }, {
    id: 'process',
    label: 'Hammadde & Proses',
    idx: '06'
  }, {
    id: 'ets',
    label: 'ETS Kapsam Verileri',
    idx: '07'
  }, {
    id: 'activity',
    label: 'Faaliyet Kayıtları',
    idx: '08'
  }];
  const storeKey = 'fa_carbon_entry_' + year + '_' + tab;

  // Kaydedilmiş değerleri geri yükle (tab/yıl değişince)
  React.useEffect(() => {
    try {
      const raw = localStorage.getItem(storeKey);
      if (!raw || !bodyRef.current) return;
      const vals = JSON.parse(raw);
      const inputs = bodyRef.current.querySelectorAll('input');
      inputs.forEach((inp, i) => {
        if (vals[i] != null && !inp.readOnly) inp.value = vals[i];
      });
    } catch (e) {}
  }, [tab, year]);
  const flashToast = msg => {
    setToast(msg);
    setTimeout(() => setToast(''), 2600);
  };
  const handleSave = () => {
    try {
      const inputs = bodyRef.current ? bodyRef.current.querySelectorAll('input') : [];
      const vals = Array.prototype.map.call(inputs, inp => inp.value);
      localStorage.setItem(storeKey, JSON.stringify(vals));
      const label = (tabs.find(t => t.id === tab) || {}).label || '';
      flashToast('✓ ' + label + ' bölümü kaydedildi (' + year + ')');
    } catch (e) {
      flashToast('Kaydedilemedi: ' + e.message);
    }
  };
  const handleTemplate = () => {
    const rows = [['Focus Academy — Karbon Envanteri Veri Şablonu'], ['Yıl', year, '', 'ISO 14064-1 · CBAM'], [], ['Kategori', 'Kaynak / Faaliyet', 'Tesis', 'Miktar', 'Birim', 'Dönem', 'Belge No', 'Not'], ['K1', 'Doğalgaz (sabit yanma)', '', '', 'Sm³', year, '', ''], ['K1', 'Motorin (hareketli)', '', '', 'L', year, '', ''], ['K1', 'Proses (karbonat)', '', '', 'ton', year, '', ''], ['K2', 'Şebeke elektriği', '', '', 'kWh', year, '', ''], ['K3', 'Personel ulaşımı', '', '', 'km', year, '', ''], ['K3', 'Ürün nakliye', '', '', 'tkm', year, '', ''], ['K4', 'Satın alınan hammadde', '', '', 'ton', year, '', '']];
    faDownloadCSV('karbon-envanter-sablonu-' + year + '.csv', rows);
    flashToast('Şablon indirildi: karbon-envanter-sablonu-' + year + '.csv');
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "tag"
  }, "VER\u0130 G\u0130R\u0130\u015E\u0130 \xB7 ", year), /*#__PURE__*/React.createElement("h1", {
    className: "page-title"
  }, "Envanter Veri Giri\u015Fi"), /*#__PURE__*/React.createElement("div", {
    className: "page-sub"
  }, "Seramik \xFCretim tesisiniz i\xE7in ISO 14064-1, EU ETS MRR ve CBAM hazırlığına yönelik veri toplama. Lokasyon, personel, enerji, proses ve ETS kapsam bilgileri.")), /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: {
      gap: 8
    }
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn ghost",
    onClick: handleTemplate
  }, /*#__PURE__*/React.createElement(Icons.Download, {
    size: 13
  }), "\u015Eablon indir"), /*#__PURE__*/React.createElement("button", {
    className: "btn primary",
    onClick: handleSave
  }, /*#__PURE__*/React.createElement(Icons.Check, {
    size: 13
  }), "Kaydet"))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 2,
      borderBottom: '1px solid var(--line)',
      overflowX: 'auto'
    }
  }, tabs.map(t => /*#__PURE__*/React.createElement("button", {
    key: t.id,
    onClick: () => setTab(t.id),
    style: {
      padding: '12px 18px',
      fontSize: 12.5,
      fontFamily: 'var(--mono)',
      textTransform: 'uppercase',
      letterSpacing: '0.06em',
      color: tab === t.id ? 'var(--ink)' : 'var(--ink-3)',
      borderBottom: `2px solid ${tab === t.id ? 'var(--clay)' : 'transparent'}`,
      marginBottom: -1,
      whiteSpace: 'nowrap'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--ink-4)',
      marginRight: 6
    }
  }, t.idx), t.label))), /*#__PURE__*/React.createElement("div", {
    ref: bodyRef
  }, tab === 'company' && /*#__PURE__*/React.createElement(EntryCompany, null), tab === 'locations' && /*#__PURE__*/React.createElement(EntryLocations, null), tab === 'employees' && /*#__PURE__*/React.createElement(EntryEmployees, null), tab === 'production' && /*#__PURE__*/React.createElement(EntryProduction, null), tab === 'energy' && /*#__PURE__*/React.createElement(EntryEnergy, null), tab === 'process' && /*#__PURE__*/React.createElement(EntryProcess, null), tab === 'ets' && /*#__PURE__*/React.createElement(EntryETS, null), tab === 'activity' && /*#__PURE__*/React.createElement(EntryActivity, null)), toast && /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'fixed',
      bottom: 24,
      left: '50%',
      transform: 'translateX(-50%)',
      background: '#2a2520',
      color: '#e8e2d6',
      padding: '12px 22px',
      borderRadius: 6,
      fontSize: 13.5,
      boxShadow: '0 8px 30px rgba(0,0,0,0.35)',
      zIndex: 99999,
      maxWidth: '90vw'
    }
  }, toast));
}
function Field({
  label,
  value,
  unit,
  type = 'text',
  readOnly,
  cols = 1
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "form-row",
    style: {
      gridColumn: `span ${cols}`
    }
  }, /*#__PURE__*/React.createElement("label", null, label), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("input", {
    type: type,
    defaultValue: value,
    readOnly: readOnly,
    style: {
      width: '100%',
      paddingRight: unit ? 54 : 12
    }
  }), unit && /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      right: 10,
      top: '50%',
      transform: 'translateY(-50%)',
      fontFamily: 'var(--mono)',
      fontSize: 11,
      color: 'var(--ink-3)'
    }
  }, unit)));
}
function EntryCompany() {
  return /*#__PURE__*/React.createElement("div", {
    className: "grid-2",
    style: {
      gridTemplateColumns: '2fr 1fr'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "T\xFCzel ki\u015Filik ve tan\u0131mlama"), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, "ISO 14064-1 \xB7 \xA75.1 Kurulu\u015F s\u0131n\u0131rlar\u0131"))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement(Field, {
    label: "Ticari unvan",
    value: COMPANY.name,
    cols: 3
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Vergi no",
    value: COMPANY.taxId
  }), /*#__PURE__*/React.createElement(Field, {
    label: "NACE kodu",
    value: COMPANY.nace,
    cols: 2
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Raporlama y\u0131l\u0131",
    value: COMPANY.reportingYear
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Baz y\u0131l",
    value: "2019"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Konsolidasyon",
    value: "Operasyonel kontrol"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Ciro",
    value: COMPANY.revenue.toLocaleString('tr-TR'),
    unit: "TL",
    cols: 1
  }), /*#__PURE__*/React.createElement(Field, {
    label: "\xDCretim hacmi",
    value: COMPANY.productionVolume.toLocaleString('tr-TR'),
    unit: "m\xB2"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Toplam tesis alan\u0131",
    value: COMPANY.totalArea.toLocaleString('tr-TR'),
    unit: "m\xB2"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 16,
      padding: 14,
      border: '1px solid var(--line)',
      borderRadius: 3
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "small-caps",
    style: {
      marginBottom: 6
    }
  }, "ETS KAPSAMI"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13.5
    }
  }, COMPANY.etsScope, " \u2014 ", COMPANY.etsActivity))), /*#__PURE__*/React.createElement("div", {
    className: "col",
    style: {
      gap: 16
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card",
    style: {
      background: 'var(--char)',
      color: '#e8e2d6',
      borderColor: 'var(--char)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "small-caps",
    style: {
      color: '#9a8f7e'
    }
  }, "VER\u0130 TAMAMLANMA"), /*#__PURE__*/React.createElement("div", {
    className: "num",
    style: {
      fontSize: 48,
      fontWeight: 500,
      color: 'var(--kiln)',
      marginTop: 6
    }
  }, "%87"), /*#__PURE__*/React.createElement("div", {
    style: {
      height: 4,
      background: 'rgba(255,255,255,0.1)',
      marginTop: 10,
      borderRadius: 2
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: '87%',
      height: '100%',
      background: 'var(--kiln)',
      borderRadius: 2
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 14,
      fontFamily: 'var(--mono)',
      fontSize: 11,
      color: '#9a8f7e',
      lineHeight: 1.7
    }
  }, /*#__PURE__*/React.createElement("div", null, "\u015E\u0130RKET \u2713 \xB7 LOKASYON \u2713 \xB7 \xC7ALI\u015EAN \u2713"), /*#__PURE__*/React.createElement("div", null, "\xDCRET\u0130M \u2713 \xB7 ENERJ\u0130 \u2713 \xB7 PROSES \u25D4 %78"), /*#__PURE__*/React.createElement("div", null, "ETS \u25D4 %62 \xB7 FAAL\u0130YET \u2713"))), /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "small-caps"
  }, "ENVANTER DO\u011ERULAMA"), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 10,
      fontSize: 13
    }
  }, "T\xFCrk Standartlar\u0131 Enstit\xFCs\xFC"), /*#__PURE__*/React.createElement("div", {
    className: "mono text-sm text-dim"
  }, "Do\u011Frulay\u0131c\u0131: Z. Ayd\u0131n"), /*#__PURE__*/React.createElement("div", {
    className: "mono text-sm text-dim"
  }, "Sonraki denetim: 06.05.2026"))));
}
function EntryLocations() {
  return /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "Tesis ve lokasyonlar"), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, "Operasyonel kontrol kapsam\u0131ndaki tesisler \xB7 ETS kapsam\u0131 ayr\u0131 i\u015Faretlenir")), /*#__PURE__*/React.createElement("button", {
    className: "btn ghost"
  }, /*#__PURE__*/React.createElement(Icons.Plus, {
    size: 12
  }), "Tesis ekle")), /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Tesis"), /*#__PURE__*/React.createElement("th", null, "T\xFCr"), /*#__PURE__*/React.createElement("th", null, "\u015Eehir"), /*#__PURE__*/React.createElement("th", {
    className: "num"
  }, "\xC7al\u0131\u015Fan"), /*#__PURE__*/React.createElement("th", {
    className: "num"
  }, "Alan (m\xB2)"), /*#__PURE__*/React.createElement("th", {
    className: "num"
  }, "\xDCretim (m\xB2)"), /*#__PURE__*/React.createElement("th", {
    className: "num"
  }, "F\u0131r\u0131n"), /*#__PURE__*/React.createElement("th", {
    className: "num"
  }, "Kurulu\u015F"), /*#__PURE__*/React.createElement("th", null, "ETS"))), /*#__PURE__*/React.createElement("tbody", null, LOCATIONS.map(l => /*#__PURE__*/React.createElement("tr", {
    key: l.id
  }, /*#__PURE__*/React.createElement("td", {
    style: {
      fontWeight: 500
    }
  }, l.name, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 11,
      color: 'var(--ink-3)',
      fontFamily: 'var(--mono)'
    }
  }, l.address)), /*#__PURE__*/React.createElement("td", {
    style: {
      color: 'var(--ink-3)'
    }
  }, l.type), /*#__PURE__*/React.createElement("td", null, l.city), /*#__PURE__*/React.createElement("td", {
    className: "num"
  }, l.employees), /*#__PURE__*/React.createElement("td", {
    className: "num"
  }, l.area.toLocaleString('tr-TR')), /*#__PURE__*/React.createElement("td", {
    className: "num"
  }, l.productionM2 ? l.productionM2.toLocaleString('tr-TR') : '—'), /*#__PURE__*/React.createElement("td", {
    className: "num"
  }, l.kilnCount || '—'), /*#__PURE__*/React.createElement("td", {
    className: "num text-dim"
  }, l.established), /*#__PURE__*/React.createElement("td", null, l.etsCovered ? /*#__PURE__*/React.createElement("span", {
    className: "status-pill ok"
  }, "Kapsam i\xE7i") : /*#__PURE__*/React.createElement("span", {
    className: "status-pill pending"
  }, "D\u0131\u015F\u0131")))))));
}
function EntryEmployees() {
  return /*#__PURE__*/React.createElement("div", {
    className: "grid-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "Personel profili"), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, "K3 \xB7 \u0130\u015Fe gidi\u015F-geli\u015F hesaplamas\u0131 i\xE7in"))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement(Field, {
    label: "Toplam \xE7al\u0131\u015Fan",
    value: "684"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Beyaz yaka oran\u0131",
    value: "22",
    unit: "%"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Vardiya say\u0131s\u0131",
    value: "3"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Ortalama mesafe (tek y\xF6n)",
    value: "18",
    unit: "km"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Servis kullan\u0131m\u0131",
    value: "78",
    unit: "%"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "\xD6zel ara\xE7 oran\u0131",
    value: "18",
    unit: "%"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Toplu ta\u015F\u0131ma",
    value: "4",
    unit: "%"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Y\u0131ll\u0131k \xE7al\u0131\u015Fma g\xFCn\xFC",
    value: "252",
    unit: "g\xFCn"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "\u0130\u015F seyahatleri (y\u0131ll\u0131k)"), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, "K3 \xB7 \u0130\xE7 ve uluslararas\u0131"))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement(Field, {
    label: "U\xE7u\u015F \u2014 i\xE7 hat",
    value: "124000",
    unit: "km"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "U\xE7u\u015F \u2014 d\u0131\u015F hat",
    value: "60000",
    unit: "km"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Kiral\u0131k ara\xE7",
    value: "38400",
    unit: "km"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Konaklama",
    value: "2400",
    unit: "gece"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Ziyaret\xE7i ula\u015F\u0131m\u0131",
    value: "47000",
    unit: "km"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Karbonu dengelenmi\u015F",
    value: "0",
    unit: "%"
  }))));
}
function EntryProduction() {
  return /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "\xDCretim ve \xFCr\xFCn verileri"), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, "ETS benchmarking ve CBAM beyan\u0131 i\xE7in \xB7 tesis bazl\u0131"))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(5, 1fr)',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement(Field, {
    label: "Yer karosu",
    value: "4820000",
    unit: "m\xB2"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Duvar karosu",
    value: "2240000",
    unit: "m\xB2"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Porselen granit",
    value: "1180000",
    unit: "m\xB2"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Vitrifiye",
    value: "180000",
    unit: "ad"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Toplam (e\u015Fde\u011Fer)",
    value: "8420000",
    unit: "m\xB2",
    readOnly: true
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Ortalama kal\u0131nl\u0131k",
    value: "9.8",
    unit: "mm"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Ortalama k\xFCtle",
    value: "20.4",
    unit: "kg/m\xB2"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Pi\u015Firim ortalama",
    value: "1180",
    unit: "\xB0C"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "F\u0131r\u0131n kapasitesi",
    value: "23400",
    unit: "m\xB2/g\xFCn"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Hurda oran\u0131",
    value: "3.8",
    unit: "%"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 18,
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: 12
    }
  }, LOCATIONS.filter(l => l.productionM2 > 0).map(l => /*#__PURE__*/React.createElement("div", {
    key: l.id,
    style: {
      padding: 14,
      border: '1px solid var(--line)',
      borderRadius: 3
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "small-caps"
  }, l.name.toUpperCase()), /*#__PURE__*/React.createElement("div", {
    className: "num",
    style: {
      fontSize: 22,
      fontWeight: 500,
      marginTop: 4
    }
  }, (l.productionM2 / 1000000).toFixed(2), "M", /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 11,
      color: 'var(--ink-3)',
      marginLeft: 4
    }
  }, "m\xB2")), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 11,
      fontFamily: 'var(--mono)',
      color: 'var(--ink-3)',
      marginTop: 4
    }
  }, l.kilnCount, " f\u0131r\u0131n \xB7 ", l.employees, " \xE7al\u0131\u015Fan")))));
}
function EntryEnergy() {
  return /*#__PURE__*/React.createElement("div", {
    className: "col",
    style: {
      gap: 16
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "Yak\u0131t t\xFCketimi (K1)"), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, "Sabit + hareketli kaynaklar \xB7 y\u0131ll\u0131k toplam"))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement(Field, {
    label: "Do\u011Falgaz (f\u0131r\u0131n)",
    value: "46280000",
    unit: "Sm\xB3"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Do\u011Falgaz (yard\u0131mc\u0131)",
    value: "1840000",
    unit: "Sm\xB3"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Motorin (servis)",
    value: "425000",
    unit: "L"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Motorin (forklift)",
    value: "2200",
    unit: "L"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Benzin",
    value: "1450",
    unit: "L"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "LPG",
    value: "0",
    unit: "kg"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "Sat\u0131n al\u0131nan enerji (K2)"), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, "\u015Eebeke + YEK-G \xB7 tesis bazl\u0131 ayr\u0131m"))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement(Field, {
    label: "\u015Eebeke elektri\u011Fi \u2014 F1",
    value: "19800000",
    unit: "kWh"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "\u015Eebeke elektri\u011Fi \u2014 F2",
    value: "12600000",
    unit: "kWh"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "\u015Eebeke \u2014 \u0130zmir",
    value: "2150000",
    unit: "kWh"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "\u015Eebeke \u2014 \u0130stanbul",
    value: "482000",
    unit: "kWh"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "\u015Eebeke \u2014 Ankara",
    value: "85000",
    unit: "kWh"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "YEK-G sertifikal\u0131",
    value: "0",
    unit: "kWh"
  })))));
}
function EntryProcess() {
  return /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "Hammadde ve proses verileri"), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, "K1 proses + K4 sat\u0131n al\u0131nan \xB7 karbonat i\xE7eri\u011Fi kritik"))), /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Malzeme"), /*#__PURE__*/React.createElement("th", {
    className: "num"
  }, "Miktar (ton)"), /*#__PURE__*/React.createElement("th", {
    className: "num"
  }, "Karbonat i\xE7eri\u011Fi"), /*#__PURE__*/React.createElement("th", {
    className: "num"
  }, "CO\u2082 fakt\xF6r\xFC"), /*#__PURE__*/React.createElement("th", null, "Kaynak"), /*#__PURE__*/React.createElement("th", null, "ETS"))), /*#__PURE__*/React.createElement("tbody", null, [['Kil (ana matriks)', 58189, '10.2%', '640 kgCO₂/t', 'TGA 2023 — şirket', true], ['Feldspat', 24800, '0.03%', '143 kgCO₂/t', 'Ecoinvent 3.9', true], ['Kaolen', 8200, '—', 'K1 yok', 'Ecoinvent 3.9', false], ['Karbonat (Na₂CO₃+CaCO₃)', 3840, '44%', '440 kgCO₂/t', 'IPCC 2006', true], ['Kireç taşı (CaCO₃)', 134, '44%', '440 kgCO₂/t', 'IPCC 2006', true], ['Kuvars', 6200, '—', 'K1 yok', 'Ecoinvent 3.9', false], ['Sır ve pigment', 1480, '—', 'K4 yalnız', 'Ecoinvent 3.9', false]].map((row, i) => /*#__PURE__*/React.createElement("tr", {
    key: i
  }, /*#__PURE__*/React.createElement("td", {
    style: {
      fontWeight: 500
    }
  }, row[0]), /*#__PURE__*/React.createElement("td", {
    className: "num"
  }, row[1].toLocaleString('tr-TR')), /*#__PURE__*/React.createElement("td", {
    className: "num mono"
  }, row[2]), /*#__PURE__*/React.createElement("td", {
    className: "num mono",
    style: {
      color: row[4] ? 'var(--clay)' : 'var(--ink-3)'
    }
  }, row[3]), /*#__PURE__*/React.createElement("td", {
    style: {
      color: 'var(--ink-3)',
      fontFamily: 'var(--mono)',
      fontSize: 11.5
    }
  }, row[4]), /*#__PURE__*/React.createElement("td", null, row[5] ? /*#__PURE__*/React.createElement("span", {
    className: "status-pill ok"
  }, "Kapsam i\xE7i") : /*#__PURE__*/React.createElement("span", {
    className: "status-pill pending"
  }, "\u2014")))))));
}
function EntryETS() {
  return /*#__PURE__*/React.createElement("div", {
    className: "grid-2",
    style: {
      gridTemplateColumns: '2fr 1fr'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "EU ETS / TR-ETS MRR verileri"), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, "Annex I faaliyet \xB7 Seramik \xFCr\xFCnleri imalat\u0131"))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 14,
      marginBottom: 16
    }
  }, /*#__PURE__*/React.createElement(Field, {
    label: "Kurulu kapasite",
    value: "32400",
    unit: "ton/y\u0131l"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Y\u0131ll\u0131k faaliyet seviyesi",
    value: "28720",
    unit: "ton/y\u0131l"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Tesis tan\u0131mlay\u0131c\u0131 (ID)",
    value: "TR-ETS-0247"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "\u0130zleme plan\u0131 revizyonu",
    value: "v3.2 \xB7 04.2024"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Do\u011Frulay\u0131c\u0131 (AV)",
    value: "Bureau Veritas TR-AV-04"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Raporlama kategorisi",
    value: "Kategori C (>500k tCO\u2082/y\u0131l de\u011Fil) \u2014 B"
  })), /*#__PURE__*/React.createElement("div", {
    className: "small-caps",
    style: {
      marginBottom: 8
    }
  }, "KAPSAMA DAH\u0130L KAYNAKLAR"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 8
    }
  }, ETS.scope.map((s, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    style: {
      padding: '6px 12px',
      border: '1px solid var(--line)',
      borderRadius: 3,
      fontSize: 12,
      fontFamily: 'var(--mono)',
      background: 'var(--kiln-bg)',
      color: 'var(--clay)'
    }
  }, s))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 16,
      padding: 14,
      background: 'var(--surface-2)',
      borderRadius: 3,
      fontSize: 12.5,
      lineHeight: 1.5
    }
  }, /*#__PURE__*/React.createElement("strong", {
    style: {
      fontFamily: 'var(--mono)',
      fontSize: 11,
      textTransform: 'uppercase',
      letterSpacing: '0.08em',
      color: 'var(--ink-3)'
    }
  }, "Tier se\xE7imi"), /*#__PURE__*/React.createElement("br", null), "Do\u011Falgaz yanmas\u0131 Tier 2 (PCS: \u015Firket \xF6l\xE7\xFCm\xFC), proses emisyonlar\u0131 Tier 3 (TGA analizi ile karbonat i\xE7eri\u011Fi). Belirsizlik \xB1 %1.8.")), /*#__PURE__*/React.createElement("div", {
    className: "col",
    style: {
      gap: 16
    }
  }, /*#__PURE__*/React.createElement(Field, {
    label: "\xDCcretsiz tahsisat (2022)",
    value: ETS.freeAllocation.toLocaleString('tr-TR'),
    unit: "EUA"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Do\u011Frulanm\u0131\u015F emisyon",
    value: ETS.verified.toLocaleString('tr-TR'),
    unit: "tCO\u2082e"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Sat\u0131n al\u0131nan EUA",
    value: "0",
    unit: "adet"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Teslim edilecek (30.04)",
    value: ETS.surrenderRequired.toLocaleString('tr-TR'),
    unit: "EUA"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Denge",
    value: ETS.balance.toLocaleString('tr-TR'),
    unit: "EUA"
  }), /*#__PURE__*/React.createElement(Field, {
    label: "Ortalama EUA fiyat\u0131 (2022, \xF6rnek veri)",
    value: ETS.price2022,
    unit: "\u20AC"
  })));
}
function EntryActivity() {
  return /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "Son faaliyet kay\u0131tlar\u0131"), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, "Sistem + manuel giri\u015Fler \xB7 onay bekleyenler sar\u0131"))), /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Tarih"), /*#__PURE__*/React.createElement("th", null, "Kullan\u0131c\u0131"), /*#__PURE__*/React.createElement("th", null, "Kategori"), /*#__PURE__*/React.createElement("th", null, "Tesis"), /*#__PURE__*/React.createElement("th", {
    className: "num"
  }, "Miktar"), /*#__PURE__*/React.createElement("th", {
    className: "num"
  }, "tCO\u2082e"), /*#__PURE__*/React.createElement("th", null, "Durum"))), /*#__PURE__*/React.createElement("tbody", null, RECENT_ENTRIES.map((e, i) => /*#__PURE__*/React.createElement("tr", {
    key: i
  }, /*#__PURE__*/React.createElement("td", {
    className: "mono text-sm"
  }, e.date), /*#__PURE__*/React.createElement("td", null, e.user), /*#__PURE__*/React.createElement("td", null, e.category), /*#__PURE__*/React.createElement("td", null, e.facility), /*#__PURE__*/React.createElement("td", {
    className: "num"
  }, e.value.toLocaleString('tr-TR'), " ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--ink-3)'
    }
  }, e.unit)), /*#__PURE__*/React.createElement("td", {
    className: "num",
    style: {
      color: 'var(--clay)',
      fontWeight: 500
    }
  }, e.co2e.toLocaleString('tr-TR', {
    maximumFractionDigits: 2
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
    className: `status-pill ${e.status}`
  }, e.status === 'ok' ? 'Onaylı' : e.status === 'warn' ? 'İncele' : 'Beklemede')))))));
}
Object.assign(window, {
  DataEntry
});

// === pages.jsx ===
// Entry, Reports, Goals, Tips, Scopes pages

function faReportWindow(year, title) {
  const d = DATA_BY_YEAR[year];
  const prev = DATA_BY_YEAR[year - 1];
  const deltaPct = prev ? (d.total - prev.total) / prev.total * 100 : 0;
  const baseline = DATA_BY_YEAR[2019].total;
  const target = baseline * 0.54;
  const sbti = Math.max(0, Math.min(100, (baseline - d.total) / (baseline - target) * 100));
  const ets = ETS_SCENARIOS.find(s => s.year === year) || ETS_SCENARIOS[ETS_SCENARIOS.length - 1];
  const gap = ets.emissions - ets.allocation;
  const cost = Math.max(0, gap) * ets.price;
  const fmt = n => Math.round(n).toLocaleString('tr-TR');
  const co = typeof COMPANY !== 'undefined' && COMPANY.name || 'Kuruluş';
  const reportTitle = title || 'ISO 14064-1 Sera Gazı Envanter Raporu';
  const catRows = CATEGORIES.map(c => `<tr><td>K${c.num}</td><td>${c.title}</td><td class="r">${fmt(d[c.key])}</td><td class="r">${(d[c.key] / d.total * 100).toFixed(1)}%</td></tr>`).join('');
  const tipRows = TIPS.slice(0, 4).map((t, i) => `<tr><td>${i + 1}</td><td><b>${t.title}</b><div class="muted">${t.body}</div></td><td class="r nowrap">${t.impact}</td><td class="c">${t.time}</td></tr>`).join('');
  const html = `<!DOCTYPE html><html lang="tr"><head><meta charset="utf-8"><title>${reportTitle} · ${co} · ${year}</title>
<style>
@page { size: A4; margin: 18mm; }
* { box-sizing: border-box; }
body { font-family: 'Inter', system-ui, sans-serif; color: #1e1a17; line-height: 1.5; margin: 0; }
.head { border-bottom: 3px solid #b24a2a; padding-bottom: 14px; margin-bottom: 22px; display: flex; justify-content: space-between; align-items: flex-end; }
.brand { font-weight: 700; font-size: 18px; color: #b24a2a; letter-spacing: -.3px; }
.brand small { display: block; font-weight: 400; font-size: 10px; color: #867c70; text-transform: uppercase; letter-spacing: 1.5px; margin-top: 3px; }
h1 { font-size: 21px; margin: 0 0 4px; }
.sub { color: #867c70; font-size: 12px; }
.kpis { display: flex; gap: 10px; margin: 18px 0; }
.kpi { flex: 1; border: 1px solid #e7dfcc; border-radius: 8px; padding: 12px; }
.kpi .l { font-size: 10px; text-transform: uppercase; letter-spacing: 1px; color: #867c70; }
.kpi .v { font-size: 22px; font-weight: 700; color: #b24a2a; margin-top: 4px; }
.kpi .u { font-size: 10px; color: #867c70; }
h2 { font-size: 14px; margin: 22px 0 8px; padding-bottom: 5px; border-bottom: 1px solid #e7dfcc; }
table { width: 100%; border-collapse: collapse; font-size: 12px; }
th { text-align: left; color: #867c70; font-weight: 600; font-size: 10px; text-transform: uppercase; letter-spacing: .5px; border-bottom: 1px solid #d9cfbb; padding: 6px 8px; }
td { padding: 6px 8px; border-bottom: 1px solid #f0ebe0; vertical-align: top; }
.r { text-align: right; } .c { text-align: center; } .nowrap { white-space: nowrap; }
.muted { color: #867c70; font-size: 10.5px; margin-top: 2px; }
.box { background: #faf6ee; border: 1px solid #e7dfcc; border-radius: 8px; padding: 12px 14px; font-size: 12px; }
.foot { margin-top: 28px; padding-top: 12px; border-top: 1px solid #e7dfcc; font-size: 10px; color: #867c70; display: flex; justify-content: space-between; }
@media print { .noprint { display: none; } }
.noprint { text-align: center; margin: 14px 0 0; }
.btn { background: #b24a2a; color: #fff; border: none; padding: 9px 18px; border-radius: 6px; font-size: 13px; cursor: pointer; }
</style></head><body>
<div class="head"><div><div class="brand">Focus Academy<small>Belgelendirme & Sürdürülebilirlik</small></div></div><div style="text-align:right" class="sub">Rapor tarihi: ${new Date().toLocaleDateString('tr-TR')}<br>ISO 14064-1 · GHG Protocol</div></div>
<h1>${reportTitle}</h1>
<div class="sub">${co} · Raporlama dönemi ${year}</div>
<div class="kpis">
  <div class="kpi"><div class="l">Toplam</div><div class="v">${fmt(d.total)}</div><div class="u">tCO₂e · ${deltaPct < 0 ? '▼' : '▲'} %${Math.abs(deltaPct).toFixed(1)} vs ${year - 1}</div></div>
  <div class="kpi"><div class="l">Kapsam 1</div><div class="v">${fmt(d.k1)}</div><div class="u">%${(d.k1 / d.total * 100).toFixed(0)} pay</div></div>
  <div class="kpi"><div class="l">Kapsam 2</div><div class="v">${fmt(d.k2)}</div><div class="u">%${(d.k2 / d.total * 100).toFixed(0)} pay</div></div>
  <div class="kpi"><div class="l">Kapsam 3-6</div><div class="v">${fmt(d.k3 + d.k4 + d.k5 + d.k6)}</div><div class="u">%${((d.k3 + d.k4 + d.k5 + d.k6) / d.total * 100).toFixed(0)} pay</div></div>
</div>
<h2>Kategori bazlı emisyon dağılımı</h2>
<table><thead><tr><th>Kat.</th><th>Tanım</th><th class="r">tCO₂e</th><th class="r">Pay</th></tr></thead><tbody>${catRows}<tr style="font-weight:700;border-top:2px solid #1e1a17"><td colspan="2">TOPLAM</td><td class="r">${fmt(d.total)}</td><td class="r">100%</td></tr></tbody></table>
<h2>ETS / CBAM yükümlülük özeti · ${year}</h2>
<div class="box">Doğrulanmış (ETS kapsamı) emisyon: <b>${fmt(ets.emissions)} tCO₂e</b> · Ücretsiz tahsisat: <b>${fmt(ets.allocation)} EUA</b> · Açık: <b>${fmt(Math.max(0, gap))} EUA</b><br>Tahmini yükümlülük maliyeti (EUA ${ets.price} €/ton, örnek veri): <b style="color:#b24a2a">€${fmt(cost)}</b> · Teslim: 30.04.${year + 1}</div>
<h2>SBTi 1.5°C hedef ilerlemesi</h2>
<div class="box">Baz yıl (2019): <b>${fmt(baseline)} tCO₂e</b> · 2030 hedefi (−%46): <b>${fmt(target)} tCO₂e</b> · Mevcut ilerleme: <b style="color:#b24a2a">%${sbti.toFixed(0)}</b></div>
<h2>Öncelikli azaltım önerileri</h2>
<table><thead><tr><th>#</th><th>Öneri</th><th class="r">Etki</th><th class="c">Süre</th></tr></thead><tbody>${tipRows}</tbody></table>
<div class="box" style="margin-top:18px">Bu rapor Focus Academy karbon platformu tarafından otomatik üretilmiştir. Resmî CBAM beyanı, ISO 14064-1 belgelendirmesi veya SBTi başvurusu için sonuçların bağımsız doğrulayıcı tarafından onaylanması gerekir.</div>
<div class="foot"><span>© Focus Academy · www.focusacademy.com.tr</span><span>${reportTitle} · ${year}</span></div>
<div class="noprint"><button class="btn" onclick="window.print()">PDF olarak kaydet / Yazdır</button></div>
</body></html>`;
  const w = window.open('', '_blank');
  if (!w) {
    alert('PDF için açılır pencere iznini verin.');
    return;
  }
  w.document.write(html);
  w.document.close();
  w.focus();
  setTimeout(() => {
    try {
      w.print();
    } catch (e) {}
  }, 500);
}
function EntryPage({
  year
}) {
  const [cat, setCat] = React.useState('k1-gas');
  const [amount, setAmount] = React.useState('1000000');
  const factors = {
    'k1-gas': {
      label: 'K1 · Doğalgaz (sabit yanma)',
      factor: 1.95,
      unit: 'Sm³',
      factorUnit: 'kgCO₂e/Sm³',
      ref: 'IPCC 2006'
    },
    'k1-diesel': {
      label: 'K1 · Motorin (hareketli)',
      factor: 2.68,
      unit: 'L',
      factorUnit: 'kgCO₂e/L',
      ref: 'DEFRA 2024'
    },
    'k1-clay': {
      label: 'K1 · Kil (proses)',
      factor: 0.64,
      unit: 'ton',
      factorUnit: 'kgCO₂e/ton',
      ref: 'IPCC AR6'
    },
    'k1-refrig': {
      label: 'K1 · Soğutucu gaz sızıntısı',
      factor: 2088,
      unit: 'kg',
      factorUnit: 'kgCO₂e/kg R404A',
      ref: 'IPCC AR5'
    },
    'k2-elec': {
      label: 'K2 · Elektrik (şebeke)',
      factor: 0.40,
      unit: 'kWh',
      factorUnit: 'kgCO₂e/kWh',
      ref: 'TEİAŞ 2023'
    },
    'k3-freight': {
      label: 'K3 · Ürün nakliye',
      factor: 0.08,
      unit: 'tkm',
      factorUnit: 'kgCO₂e/tkm',
      ref: 'DEFRA 2024'
    },
    'k3-commute': {
      label: 'K3 · Personel ulaşımı',
      factor: 0.17,
      unit: 'km',
      factorUnit: 'kgCO₂e/km',
      ref: 'DEFRA 2024'
    },
    'k4-raw': {
      label: 'K4 · Hammadde',
      factor: 220,
      unit: 'ton',
      factorUnit: 'kgCO₂e/ton',
      ref: 'Ecoinvent 3.9'
    }
  };
  const active = factors[cat];
  const estimate = (Number(amount) || 0) * active.factor / 1000;
  return /*#__PURE__*/React.createElement("div", {
    className: "page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "tag"
  }, "VER\u0130 G\u0130R\u0130\u015E\u0130 \xB7 ", year), /*#__PURE__*/React.createElement("h1", {
    className: "page-title"
  }, "Yeni emisyon kayd\u0131"), /*#__PURE__*/React.createElement("div", {
    className: "page-sub"
  }, "ISO 14064-1 uyumlu olarak kategori, faaliyet verisi ve emisyon fakt\xF6r\xFC girin. Tahmini emisyon otomatik hesaplan\u0131r."))), /*#__PURE__*/React.createElement("div", {
    className: "grid-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "Kategori ve faaliyet verisi"), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, "Ad\u0131m 1/2"))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 12,
      marginBottom: 18
    }
  }, Object.entries(factors).map(([k, f]) => /*#__PURE__*/React.createElement("button", {
    key: k,
    onClick: () => setCat(k),
    style: {
      padding: 14,
      border: `1px solid ${cat === k ? 'var(--clay)' : 'var(--line)'}`,
      background: cat === k ? 'var(--kiln-bg)' : 'var(--surface)',
      borderRadius: 3,
      textAlign: 'left',
      display: 'flex',
      flexDirection: 'column',
      gap: 4
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13,
      fontWeight: 500
    }
  }, f.label), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 11,
      fontFamily: 'var(--mono)',
      color: 'var(--ink-3)'
    }
  }, f.factor, " ", f.factorUnit)))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 12,
      paddingTop: 18,
      borderTop: '1px solid var(--line)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement("label", null, "Tarih"), /*#__PURE__*/React.createElement("input", {
    type: "date",
    defaultValue: "2026-04-19"
  })), /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement("label", null, "Tesis"), /*#__PURE__*/React.createElement("select", {
    defaultValue: "manisa-1"
  }, /*#__PURE__*/React.createElement("option", {
    value: "manisa-1"
  }, "Manisa Fabrika 1"), /*#__PURE__*/React.createElement("option", {
    value: "manisa-2"
  }, "Manisa Fabrika 2"), /*#__PURE__*/React.createElement("option", {
    value: "izmir"
  }, "\u0130zmir Sevkiyat"), /*#__PURE__*/React.createElement("option", {
    value: "istanbul"
  }, "\u0130stanbul GM"))), /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement("label", null, "Miktar"), /*#__PURE__*/React.createElement("input", {
    value: amount,
    onChange: e => setAmount(e.target.value),
    className: "num"
  })), /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement("label", null, "Birim"), /*#__PURE__*/React.createElement("input", {
    value: active.unit,
    readOnly: true,
    style: {
      fontFamily: 'var(--mono)'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "form-row",
    style: {
      gridColumn: 'span 2'
    }
  }, /*#__PURE__*/React.createElement("label", null, "Belge referans\u0131"), /*#__PURE__*/React.createElement("input", {
    placeholder: "Fatura no, \xF6l\xE7\xFCm cihaz\u0131 referans\u0131..."
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: {
      justifyContent: 'flex-end',
      gap: 8,
      marginTop: 18
    }
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn ghost"
  }, "\u0130ptal"), /*#__PURE__*/React.createElement("button", {
    className: "btn primary"
  }, /*#__PURE__*/React.createElement(Icons.Check, {
    size: 13
  }), "Kaydet"))), /*#__PURE__*/React.createElement("div", {
    className: "col",
    style: {
      gap: 16
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card",
    style: {
      background: 'var(--char)',
      color: '#e8e2d6',
      borderColor: 'var(--char)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--mono)',
      fontSize: 10.5,
      color: '#9a8f7e',
      textTransform: 'uppercase',
      letterSpacing: '0.1em'
    }
  }, "TAHM\u0130N\u0130 EM\u0130SYON"), /*#__PURE__*/React.createElement("div", {
    className: "num",
    style: {
      fontSize: 48,
      fontWeight: 500,
      letterSpacing: '-0.03em',
      marginTop: 8,
      color: 'var(--kiln)'
    }
  }, estimate.toLocaleString('tr-TR', {
    maximumFractionDigits: 2
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 16,
      color: '#9a8f7e',
      marginLeft: 8
    }
  }, "tCO\u2082e")), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 16,
      paddingTop: 14,
      borderTop: '1px solid rgba(255,255,255,0.12)',
      fontFamily: 'var(--mono)',
      fontSize: 11,
      color: '#9a8f7e'
    }
  }, /*#__PURE__*/React.createElement("div", null, "FAKT\xD6R \xB7 ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#e8e2d6'
    }
  }, active.factor, " ", active.factorUnit)), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 4
    }
  }, "REFERANS \xB7 ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#e8e2d6'
    }
  }, active.ref)))), /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "Son giri\u015Fler"), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, "Bu hafta \xB7 18 kay\u0131t"))), /*#__PURE__*/React.createElement("div", {
    className: "col",
    style: {
      gap: 0
    }
  }, RECENT_ENTRIES.slice(0, 4).map((e, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    style: {
      padding: '12px 0',
      borderBottom: i < 3 ? '1px solid var(--line-2)' : 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "row space-between"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13,
      fontWeight: 500
    }
  }, e.category), /*#__PURE__*/React.createElement("div", {
    className: "num",
    style: {
      fontSize: 12.5,
      color: 'var(--clay)'
    }
  }, "+", e.co2e.toLocaleString('tr-TR', {
    maximumFractionDigits: 1
  }), " t")), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 11.5,
      color: 'var(--ink-3)',
      fontFamily: 'var(--mono)',
      marginTop: 3
    }
  }, e.facility, " \xB7 ", e.user, " \xB7 ", e.date))))))));
}
function ScopesPage({
  year
}) {
  const d = DATA_BY_YEAR[year];
  return /*#__PURE__*/React.createElement("div", {
    className: "page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "tag"
  }, "KATEGOR\u0130 ANAL\u0130Z\u0130 \xB7 ", year), /*#__PURE__*/React.createElement("h1", {
    className: "page-title"
  }, "ISO 14064-1 Kategorileri"), /*#__PURE__*/React.createElement("div", {
    className: "page-sub"
  }, "6 ana kategori ve alt kaynaklar\u0131n detayl\u0131 d\xF6k\xFCm\xFC. Her sat\u0131r ayr\u0131 emisyon fakt\xF6r\xFC ve referans\u0131 ile hesaplanm\u0131\u015Ft\u0131r."))), /*#__PURE__*/React.createElement("div", {
    className: "grid-3"
  }, CATEGORIES.map(c => /*#__PURE__*/React.createElement("div", {
    key: c.key,
    className: "card",
    style: {
      position: 'relative',
      paddingLeft: 22
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      left: 0,
      top: 0,
      bottom: 0,
      width: 4,
      background: c.color
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--mono)',
      fontSize: 10.5,
      color: 'var(--ink-3)',
      textTransform: 'uppercase',
      letterSpacing: '0.1em'
    }
  }, "KATEGOR\u0130 ", c.num), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 15,
      fontWeight: 600,
      marginTop: 4,
      marginBottom: 4,
      lineHeight: 1.3
    }
  }, c.title), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12,
      color: 'var(--ink-2)'
    }
  }, c.sub), /*#__PURE__*/React.createElement("div", {
    className: "num",
    style: {
      fontSize: 26,
      fontWeight: 500,
      marginTop: 14,
      letterSpacing: '-0.02em'
    }
  }, d[c.key].toLocaleString('tr-TR'), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 12,
      color: 'var(--ink-3)',
      marginLeft: 6
    }
  }, "tCO\u2082e")), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--mono)',
      fontSize: 11,
      color: 'var(--ink-3)',
      marginTop: 4
    }
  }, (d[c.key] / d.total * 100).toFixed(1), "% toplam"), /*#__PURE__*/React.createElement("div", {
    style: {
      height: 4,
      background: 'var(--line-2)',
      borderRadius: 2,
      overflow: 'hidden',
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: '100%',
      width: `${d[c.key] / d.total * 100}%`,
      background: c.color
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "Kategori 1 \u2014 T\xFCm kaynaklar"), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, "Do\u011Frudan sera gaz\u0131 emisyonlar\u0131 \xB7 ", year))), /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Kaynak"), /*#__PURE__*/React.createElement("th", {
    className: "num"
  }, "Emisyon (tCO\u2082e)"), /*#__PURE__*/React.createElement("th", {
    className: "num"
  }, "Pay (%)"), /*#__PURE__*/React.createElement("th", null, "Fakt\xF6r referans\u0131"))), /*#__PURE__*/React.createElement("tbody", null, CAT1_2022.map((c, i) => /*#__PURE__*/React.createElement("tr", {
    key: i
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: {
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 10,
      height: 10,
      background: c.color,
      borderRadius: 2
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 500
    }
  }, c.label))), /*#__PURE__*/React.createElement("td", {
    className: "num"
  }, c.value.toLocaleString('tr-TR', {
    maximumFractionDigits: c.value < 1 ? 3 : 0
  })), /*#__PURE__*/React.createElement("td", {
    className: "num",
    style: {
      color: 'var(--ink-3)'
    }
  }, (c.value / d.k1 * 100).toFixed(2), "%"), /*#__PURE__*/React.createElement("td", {
    style: {
      color: 'var(--ink-3)',
      fontFamily: 'var(--mono)',
      fontSize: 11.5
    }
  }, ['IPCC 2006', 'IPCC AR6', 'DEFRA 2024', 'DEFRA 2024', 'DEFRA 2024', 'IPCC 2006', 'IPCC AR5', 'IPCC 2006', 'IPCC 2006', 'IPCC AR5'][i])))))));
}
function ReportsPage({
  year
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "tag"
  }, "RAPORLAR \xB7 ", year), /*#__PURE__*/React.createElement("h1", {
    className: "page-title"
  }, "Do\u011Frulanm\u0131\u015F raporlar"), /*#__PURE__*/React.createElement("div", {
    className: "page-sub"
  }, "ISO 14064-1, CDP, GRI ve SBTi \xE7er\xE7evelerine uygun, ba\u011F\u0131ms\u0131z do\u011Frulay\u0131c\u0131 taraf\u0131ndan incelenmi\u015F raporlar.")), /*#__PURE__*/React.createElement("button", {
    className: "btn primary",
    onClick: () => faReportWindow(year)
  }, /*#__PURE__*/React.createElement(Icons.Plus, {
    size: 13
  }), "Yeni rapor")), /*#__PURE__*/React.createElement("div", {
    className: "grid-3"
  }, ['ISO 14064-1', 'CDP', 'GRI 305'].map((fw, i) => /*#__PURE__*/React.createElement("div", {
    key: fw,
    className: "card",
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "row space-between"
  }, /*#__PURE__*/React.createElement("span", {
    className: "small-caps"
  }, "\xC7er\xE7eve"), /*#__PURE__*/React.createElement("span", {
    className: "status-pill ok"
  }, "Aktif")), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--serif)',
      fontSize: 32,
      fontWeight: 500
    }
  }, fw), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12,
      color: 'var(--ink-2)'
    }
  }, i === 0 && 'Sera gazı envanteri · Kategori 1-6 · Belirsizlik analizi', i === 1 && 'Climate Change 2023 questionnaire', i === 2 && '305-1, 305-2, 305-3 emisyon açıklamaları'), /*#__PURE__*/React.createElement("div", {
    className: "row space-between",
    style: {
      marginTop: 'auto',
      paddingTop: 12,
      borderTop: '1px solid var(--line-2)',
      fontFamily: 'var(--mono)',
      fontSize: 10.5,
      color: 'var(--ink-3)',
      textTransform: 'uppercase',
      letterSpacing: '0.08em'
    }
  }, /*#__PURE__*/React.createElement("span", null, "SONRAK\u0130 \xB7 ", ['Mayıs 2026', 'Haz 2026', 'Nis 2026'][i]), /*#__PURE__*/React.createElement("span", null, "%", [92, 74, 88][i]))))), /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "T\xFCm raporlar"), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, "Son 2 y\u0131l"))), /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Rapor ad\u0131"), /*#__PURE__*/React.createElement("th", null, "\xC7er\xE7eve"), /*#__PURE__*/React.createElement("th", null, "D\xF6nem"), /*#__PURE__*/React.createElement("th", null, "Tarih"), /*#__PURE__*/React.createElement("th", null, "Durum"), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", null, REPORTS.map((r, i) => /*#__PURE__*/React.createElement("tr", {
    key: i
  }, /*#__PURE__*/React.createElement("td", {
    style: {
      fontWeight: 500
    }
  }, r.name), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
    className: "status-pill pending"
  }, r.framework)), /*#__PURE__*/React.createElement("td", {
    style: {
      color: 'var(--ink-3)'
    }
  }, r.period), /*#__PURE__*/React.createElement("td", {
    className: "mono text-sm text-dim"
  }, r.generated), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
    className: "status-pill ok"
  }, r.status)), /*#__PURE__*/React.createElement("td", {
    style: {
      textAlign: 'right'
    }
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn ghost",
    style: {
      padding: '4px 10px',
      fontSize: 10
    },
    onClick: () => faReportWindow(year, r.name)
  }, /*#__PURE__*/React.createElement(Icons.Download, {
    size: 11
  }), "PDF"))))))));
}
function GoalsPage({
  year
}) {
  const baseline = DATA_BY_YEAR[2019].total;
  const current = DATA_BY_YEAR[year].total;
  const target2030 = baseline * 0.54; // 46% reduction
  const progress = (baseline - current) / (baseline - target2030) * 100;
  return /*#__PURE__*/React.createElement("div", {
    className: "page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "tag"
  }, "HEDEFLER \xB7 SBTi 1.5\xB0C YOLU"), /*#__PURE__*/React.createElement("h1", {
    className: "page-title"
  }, "Azalt\u0131m hedefleri"), /*#__PURE__*/React.createElement("div", {
    className: "page-sub"
  }, "2019 baz y\u0131l\u0131ndan 2030'a kadar %46 mutlak azalt\u0131m hedefi. SBTi taraf\u0131ndan do\u011Frulanm\u0131\u015Ft\u0131r."))), /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "2030 yolu \xB7 SBTi 1.5\xB0C"), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, "Baz y\u0131l 2019 \xB7 ", baseline.toLocaleString('tr-TR'), " tCO\u2082e \xB7 hedef %46 azalt\u0131m")), /*#__PURE__*/React.createElement("div", {
    className: "num",
    style: {
      fontSize: 32,
      fontWeight: 500,
      color: 'var(--clay)'
    }
  }, "%", progress.toFixed(0))), /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "260",
    viewBox: "0 0 900 260",
    preserveAspectRatio: "none"
  }, [0, 1, 2, 3, 4].map(i => /*#__PURE__*/React.createElement("line", {
    key: i,
    x1: "50",
    x2: "880",
    y1: 40 + i * 45,
    y2: 40 + i * 45,
    stroke: "var(--line-2)",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("line", {
    x1: "50",
    y1: "60",
    x2: "880",
    y2: "60",
    stroke: "var(--ink-3)",
    strokeWidth: "1",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("text", {
    x: "880",
    y: "55",
    textAnchor: "end",
    fontSize: "10",
    fill: "var(--ink-3)",
    fontFamily: "JetBrains Mono"
  }, "BAZ YIL 2019 \xB7 ", baseline.toLocaleString('tr-TR')), /*#__PURE__*/React.createElement("line", {
    x1: "50",
    y1: "60",
    x2: "880",
    y2: "220",
    stroke: "var(--clay)",
    strokeWidth: "2",
    strokeDasharray: "6 4"
  }), /*#__PURE__*/React.createElement("text", {
    x: "880",
    y: "235",
    textAnchor: "end",
    fontSize: "10",
    fill: "var(--clay)",
    fontFamily: "JetBrains Mono"
  }, "SBTi HEDEF\u0130 \xB7 -%46"), /*#__PURE__*/React.createElement("polyline", {
    points: [2019, 2020, 2021, 2022, 2023, 2024].map((y, i) => {
      const x = 50 + i * 166;
      const v = DATA_BY_YEAR[y].total;
      const yP = 60 + (baseline - v) / (baseline - target2030) * 160;
      return `${x},${yP}`;
    }).join(' '),
    fill: "none",
    stroke: "var(--clay)",
    strokeWidth: "2.5"
  }), [2019, 2020, 2021, 2022, 2023, 2024].map((y, i) => {
    const x = 50 + i * 166;
    const v = DATA_BY_YEAR[y].total;
    const yP = 60 + (baseline - v) / (baseline - target2030) * 160;
    return /*#__PURE__*/React.createElement("g", {
      key: y
    }, /*#__PURE__*/React.createElement("circle", {
      cx: x,
      cy: yP,
      r: "4",
      fill: "var(--clay)"
    }), /*#__PURE__*/React.createElement("text", {
      x: x,
      y: "255",
      textAnchor: "middle",
      fontSize: "10.5",
      fill: "var(--ink-3)",
      fontFamily: "JetBrains Mono"
    }, y), /*#__PURE__*/React.createElement("text", {
      x: x,
      y: yP - 10,
      textAnchor: "middle",
      fontSize: "10",
      fill: "var(--ink-2)",
      fontFamily: "JetBrains Mono"
    }, Math.round(v / 1000), "k"));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "grid-3"
  }, [{
    title: 'Mutlak emisyon azaltımı',
    sub: 'Baz yıl 2019 · 2030',
    progress: progress,
    target: 100,
    note: '-%46'
  }, {
    title: 'Yenilenebilir elektrik',
    sub: 'RE100 · 2028',
    progress: 34,
    target: 100,
    note: '%100'
  }, {
    title: 'Karbon yoğunluğu (ürün)',
    sub: 'tCO₂e/m² seramik',
    progress: 62,
    target: 100,
    note: '-%55'
  }].map((g, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: "card tech"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--serif)',
      fontSize: 48,
      fontWeight: 500,
      color: 'var(--clay)'
    }
  }, g.note), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 15,
      fontWeight: 600,
      marginTop: 6
    }
  }, g.title), /*#__PURE__*/React.createElement("div", {
    className: "small-caps",
    style: {
      marginTop: 2
    }
  }, g.sub), /*#__PURE__*/React.createElement("div", {
    style: {
      height: 6,
      background: 'var(--line-2)',
      borderRadius: 2,
      marginTop: 16,
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: '100%',
      width: `${g.progress}%`,
      background: 'var(--clay)'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "row space-between",
    style: {
      marginTop: 6,
      fontFamily: 'var(--mono)',
      fontSize: 11
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--ink-3)'
    }
  }, "\u0130lerleme"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 500
    }
  }, "%", Math.round(g.progress)))))));
}
function TipsPage() {
  return /*#__PURE__*/React.createElement("div", {
    className: "page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "tag"
  }, "\xD6NER\u0130LER \xB7 AI DESTEKL\u0130"), /*#__PURE__*/React.createElement("h1", {
    className: "page-title"
  }, "Azalt\u0131m f\u0131rsatlar\u0131"), /*#__PURE__*/React.createElement("div", {
    className: "page-sub"
  }, "Envanter verilerinizden t\xFCretilen \xF6neriler. Her \xF6neri potansiyel etki, maliyet ve s\xFCre ile \xF6nceliklendirilmi\u015Ftir."))), /*#__PURE__*/React.createElement("div", {
    className: "grid-2",
    style: {
      gridTemplateColumns: '1fr 1fr'
    }
  }, TIPS.map((t, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: "card tech"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row space-between"
  }, /*#__PURE__*/React.createElement("span", {
    className: "small-caps",
    style: {
      color: t.priority === 'high' ? 'var(--clay)' : 'var(--ink-3)'
    }
  }, t.priority === 'high' ? 'YÜKSEK ÖNCELİK' : 'ORTA ÖNCELİK'), /*#__PURE__*/React.createElement("span", {
    className: "num",
    style: {
      fontSize: 11,
      color: 'var(--ink-3)'
    }
  }, "#0", i + 1)), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 17,
      fontWeight: 600,
      marginTop: 12,
      letterSpacing: '-0.01em',
      lineHeight: 1.3
    }
  }, t.title), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13.5,
      color: 'var(--ink-2)',
      marginTop: 8,
      lineHeight: 1.5
    }
  }, t.body), /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: {
      marginTop: 18,
      paddingTop: 14,
      borderTop: '1px solid var(--line-2)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "small-caps"
  }, "Etki"), /*#__PURE__*/React.createElement("div", {
    className: "num",
    style: {
      fontSize: 14,
      fontWeight: 500,
      marginTop: 3,
      color: 'var(--clay)'
    }
  }, "-", t.impact)), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "small-caps"
  }, "Maliyet"), /*#__PURE__*/React.createElement("div", {
    className: "num",
    style: {
      fontSize: 14,
      fontWeight: 500,
      marginTop: 3
    }
  }, t.cost)), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "small-caps"
  }, "S\xFCre"), /*#__PURE__*/React.createElement("div", {
    className: "num",
    style: {
      fontSize: 14,
      fontWeight: 500,
      marginTop: 3
    }
  }, t.time)))))));
}
Object.assign(window, {
  EntryPage,
  ScopesPage,
  ReportsPage,
  GoalsPage,
  TipsPage
});

// === analysis.jsx ===
// Per-category analysis pages + ETS result page + updated reports/goals/tips

function CategoryAnalysis({
  year,
  catNum
}) {
  const cat = CATEGORIES.find(c => c.num === catNum);
  const d = DATA_BY_YEAR[year];
  const detail = {
    1: CAT1_DETAIL,
    2: CAT2_DETAIL,
    3: CAT3_DETAIL,
    4: CAT4_DETAIL,
    5: CAT5_DETAIL,
    6: CAT6_DETAIL
  }[catNum] || [];
  const total = d[cat.key];
  const prevTotal = DATA_BY_YEAR[year - 1]?.[cat.key];
  const delta = prevTotal ? (total - prevTotal) / prevTotal * 100 : 0;
  const etsRows = detail.filter(r => r.ets);
  const etsTotal = etsRows.reduce((s, r) => s + r.tco2e, 0);
  return /*#__PURE__*/React.createElement("div", {
    className: "page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "tag"
  }, "KATEGOR\u0130 ", catNum, " \xB7 ANAL\u0130Z \xB7 ", year), /*#__PURE__*/React.createElement("h1", {
    className: "page-title"
  }, cat.title), /*#__PURE__*/React.createElement("div", {
    className: "page-sub"
  }, cat.sub, ". ISO 14064-1 ve ", catNum === 1 || catNum === 2 ? 'EU ETS MRR' : 'GHG Protocol', " uyumlu tier bazl\u0131 hesaplama."))), /*#__PURE__*/React.createElement("div", {
    className: "kpi-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "kpi"
  }, /*#__PURE__*/React.createElement("div", {
    className: "kpi-label"
  }, /*#__PURE__*/React.createElement("span", {
    className: "cat-num",
    style: {
      background: cat.color
    }
  }, "K", catNum), /*#__PURE__*/React.createElement("span", null, "Toplam emisyon")), /*#__PURE__*/React.createElement("div", {
    className: "kpi-value num"
  }, total.toLocaleString('tr-TR'), /*#__PURE__*/React.createElement("span", {
    className: "unit"
  }, "tCO\u2082e")), /*#__PURE__*/React.createElement("div", {
    className: "kpi-meta"
  }, /*#__PURE__*/React.createElement("span", {
    className: `delta ${delta < 0 ? 'down' : 'up'}`
  }, delta.toFixed(1), "%"), /*#__PURE__*/React.createElement("span", null, "vs ", year - 1))), /*#__PURE__*/React.createElement("div", {
    className: "kpi"
  }, /*#__PURE__*/React.createElement("div", {
    className: "kpi-label"
  }, /*#__PURE__*/React.createElement("span", null, "Toplam paydaki oran\u0131")), /*#__PURE__*/React.createElement("div", {
    className: "kpi-value num"
  }, "%", (total / d.total * 100).toFixed(1)), /*#__PURE__*/React.createElement("div", {
    className: "kpi-meta"
  }, "envanterin ", (total / d.total * 100).toFixed(0), "%'i")), /*#__PURE__*/React.createElement("div", {
    className: "kpi"
  }, /*#__PURE__*/React.createElement("div", {
    className: "kpi-label"
  }, /*#__PURE__*/React.createElement("span", null, "Kaynak say\u0131s\u0131")), /*#__PURE__*/React.createElement("div", {
    className: "kpi-value num"
  }, detail.length), /*#__PURE__*/React.createElement("div", {
    className: "kpi-meta"
  }, detail.length ? `en büyük: ${Math.round(Math.max(...detail.map(r => r.tco2e)) / total * 100)}%` : '—')), /*#__PURE__*/React.createElement("div", {
    className: "kpi"
  }, /*#__PURE__*/React.createElement("div", {
    className: "kpi-label"
  }, /*#__PURE__*/React.createElement("span", null, "ETS kapsam\u0131")), /*#__PURE__*/React.createElement("div", {
    className: "kpi-value num"
  }, etsTotal ? etsTotal.toLocaleString('tr-TR') : '—', /*#__PURE__*/React.createElement("span", {
    className: "unit"
  }, "tCO\u2082e")), /*#__PURE__*/React.createElement("div", {
    className: "kpi-meta"
  }, etsTotal ? `${etsRows.length} kaynak` : 'kapsam dışı'))), /*#__PURE__*/React.createElement("div", {
    className: "grid-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card tech"
  }, /*#__PURE__*/React.createElement("div", {
    className: "corner-label"
  }, "FIG. K", catNum, ".1 \u2014 DA\u011EILIM"), /*#__PURE__*/React.createElement("div", {
    className: "card-head",
    style: {
      marginTop: 4
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "Kaynak bazl\u0131 da\u011F\u0131l\u0131m"), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, year, " \xB7 tCO\u2082e"))), /*#__PURE__*/React.createElement(HBar, {
    data: detail.slice(0, 8).map(r => ({
      label: r.source || r.label,
      value: r.tco2e,
      color: cat.color
    }))
  })), /*#__PURE__*/React.createElement("div", {
    className: "card tech"
  }, /*#__PURE__*/React.createElement("div", {
    className: "corner-label"
  }, "FIG. K", catNum, ".2 \u2014 YIL"), /*#__PURE__*/React.createElement("div", {
    className: "card-head",
    style: {
      marginTop: 4
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "6 y\u0131ll\u0131k trend"), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, "2019-2024 \xB7 tCO\u2082e"))), /*#__PURE__*/React.createElement(YearBarsSingle, {
    catKey: cat.key,
    color: cat.color
  }))), /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "Kaynak hesap tablosu"), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, "Faaliyet verisi \xD7 Emisyon fakt\xF6r\xFC = Emisyon \xB7 tier bazl\u0131"))), /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Kaynak"), catNum === 1 && /*#__PURE__*/React.createElement("th", null, "Alt kategori"), catNum <= 2 && /*#__PURE__*/React.createElement("th", null, "Tesis"), /*#__PURE__*/React.createElement("th", {
    className: "num"
  }, "Faaliyet verisi"), /*#__PURE__*/React.createElement("th", null, "Birim"), /*#__PURE__*/React.createElement("th", {
    className: "num"
  }, "EF"), /*#__PURE__*/React.createElement("th", null, "EF Birimi"), /*#__PURE__*/React.createElement("th", null, "Referans"), catNum <= 2 && /*#__PURE__*/React.createElement("th", null, "Tier"), /*#__PURE__*/React.createElement("th", {
    className: "num"
  }, "tCO\u2082e"), catNum === 1 && /*#__PURE__*/React.createElement("th", null, "ETS"))), /*#__PURE__*/React.createElement("tbody", null, detail.map((r, i) => /*#__PURE__*/React.createElement("tr", {
    key: i
  }, /*#__PURE__*/React.createElement("td", {
    style: {
      fontWeight: 500
    }
  }, r.source), catNum === 1 && /*#__PURE__*/React.createElement("td", {
    style: {
      color: 'var(--ink-3)'
    }
  }, r.subcat), catNum <= 2 && /*#__PURE__*/React.createElement("td", null, r.facility || '—'), /*#__PURE__*/React.createElement("td", {
    className: "num"
  }, r.activity.toLocaleString('tr-TR')), /*#__PURE__*/React.createElement("td", {
    className: "mono text-sm text-dim"
  }, r.unit), /*#__PURE__*/React.createElement("td", {
    className: "num"
  }, r.ef), /*#__PURE__*/React.createElement("td", {
    className: "mono text-sm text-dim"
  }, r.efUnit), /*#__PURE__*/React.createElement("td", {
    className: "mono text-sm text-dim"
  }, r.ref), catNum <= 2 && /*#__PURE__*/React.createElement("td", {
    className: "mono text-sm"
  }, r.tier), /*#__PURE__*/React.createElement("td", {
    className: "num",
    style: {
      fontWeight: 600,
      color: 'var(--clay)'
    }
  }, r.tco2e.toLocaleString('tr-TR', {
    maximumFractionDigits: r.tco2e < 1 ? 3 : 0
  })), catNum === 1 && /*#__PURE__*/React.createElement("td", null, r.ets ? /*#__PURE__*/React.createElement("span", {
    className: "status-pill ok"
  }, "ETS") : /*#__PURE__*/React.createElement("span", {
    className: "status-pill pending"
  }, "\u2014")))), /*#__PURE__*/React.createElement("tr", {
    style: {
      borderTop: '2px solid var(--ink)'
    }
  }, /*#__PURE__*/React.createElement("td", {
    colSpan: catNum === 1 ? 8 : catNum === 2 ? 7 : 6,
    style: {
      fontWeight: 600,
      fontFamily: 'var(--mono)',
      textTransform: 'uppercase',
      fontSize: 11,
      letterSpacing: '0.08em'
    }
  }, "TOPLAM"), /*#__PURE__*/React.createElement("td", {
    className: "num",
    style: {
      fontWeight: 700,
      fontSize: 14
    }
  }, total.toLocaleString('tr-TR')), catNum === 1 && /*#__PURE__*/React.createElement("td", null))))), catNum === 1 && /*#__PURE__*/React.createElement("div", {
    className: "callout"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "callout-label"
  }, "ETS NOTU"), /*#__PURE__*/React.createElement("div", {
    className: "callout-body"
  }, "Kategori 1 emisyonunun ", /*#__PURE__*/React.createElement("strong", null, etsTotal.toLocaleString('tr-TR'), " tCO\u2082e"), "\\'si (", (etsTotal / total * 100).toFixed(1), "%) EU ETS/TR-ETS kapsam\u0131nda izlenmekte ve her y\u0131l 30 Nisan\\'a kadar e\u015Fde\u011Fer EUA teslim edilmelidir."))));
}
function YearBarsSingle({
  catKey,
  color
}) {
  const years = [2019, 2020, 2021, 2022, 2023, 2024];
  const data = years.map(y => ({
    y,
    v: DATA_BY_YEAR[y][catKey]
  }));
  const max = Math.max(...data.map(d => d.v)) * 1.05;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "bars",
    style: {
      height: 200,
      gridTemplateColumns: `repeat(${data.length}, 1fr)`
    }
  }, data.map(d => /*#__PURE__*/React.createElement("div", {
    key: d.y,
    className: "bar-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bar",
    style: {
      height: `${d.v / max * 100}%`,
      background: color,
      width: '60%',
      margin: '0 auto',
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top: -16,
      left: 0,
      right: 0,
      textAlign: 'center',
      fontFamily: 'var(--mono)',
      fontSize: 10.5,
      color: 'var(--ink-2)'
    }
  }, Math.round(d.v / 1000), "k"))))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: `repeat(${data.length}, 1fr)`,
      gap: 6,
      marginTop: 8
    }
  }, data.map(d => /*#__PURE__*/React.createElement("div", {
    key: d.y,
    className: "bar-label"
  }, d.y))));
}
function ETSPage({
  year
}) {
  const s = ETS_SCENARIOS.find(s => s.year === year) || ETS_SCENARIOS[0];
  const balance = s.allocation - s.emissions;
  const cost = Math.max(0, -balance) * s.price;
  return /*#__PURE__*/React.createElement("div", {
    className: "page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "tag"
  }, "EU ETS / TR-ETS \xB7 SONU\xC7 \xB7 ", year), /*#__PURE__*/React.createElement("h1", {
    className: "page-title"
  }, "Emisyon Ticaret Sistemi"), /*#__PURE__*/React.createElement("div", {
    className: "page-sub"
  }, "Annex I seramik imalat\u0131 faaliyeti i\xE7in do\u011Frulanm\u0131\u015F emisyon, \xFCcretsiz tahsisat ve EUA y\xFCk\xFCml\xFCl\xFC\u011F\xFC. Benchmark: ", ETS.benchmarkEF, " tCO\u2082/m\xB2 (Phase IV).")), /*#__PURE__*/React.createElement("button", {
    className: "btn primary"
  }, /*#__PURE__*/React.createElement(Icons.Download, {
    size: 13
  }), "MRV Raporu (PDF)")), /*#__PURE__*/React.createElement("div", {
    className: "kpi-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "kpi"
  }, /*#__PURE__*/React.createElement("div", {
    className: "kpi-label"
  }, /*#__PURE__*/React.createElement("span", {
    className: "cat-num"
  }, "ETS"), /*#__PURE__*/React.createElement("span", null, "Do\u011Frulanm\u0131\u015F emisyon")), /*#__PURE__*/React.createElement("div", {
    className: "kpi-value num"
  }, s.emissions.toLocaleString('tr-TR'), /*#__PURE__*/React.createElement("span", {
    className: "unit"
  }, "tCO\u2082e")), /*#__PURE__*/React.createElement("div", {
    className: "kpi-meta"
  }, "kapsam i\xE7i \xB7 ", year)), /*#__PURE__*/React.createElement("div", {
    className: "kpi"
  }, /*#__PURE__*/React.createElement("div", {
    className: "kpi-label"
  }, /*#__PURE__*/React.createElement("span", null, "\xDCcretsiz tahsisat")), /*#__PURE__*/React.createElement("div", {
    className: "kpi-value num"
  }, s.allocation.toLocaleString('tr-TR'), /*#__PURE__*/React.createElement("span", {
    className: "unit"
  }, "EUA")), /*#__PURE__*/React.createElement("div", {
    className: "kpi-meta"
  }, "benchmark \xD7 faaliyet")), /*#__PURE__*/React.createElement("div", {
    className: "kpi"
  }, /*#__PURE__*/React.createElement("div", {
    className: "kpi-label"
  }, /*#__PURE__*/React.createElement("span", null, "Denge")), /*#__PURE__*/React.createElement("div", {
    className: "kpi-value num",
    style: {
      color: balance < 0 ? 'var(--red)' : 'var(--green)'
    }
  }, balance > 0 ? '+' : '', balance.toLocaleString('tr-TR')), /*#__PURE__*/React.createElement("div", {
    className: "kpi-meta"
  }, balance < 0 ? 'açık — satın alma' : 'fazla — satış fırsatı')), /*#__PURE__*/React.createElement("div", {
    className: "kpi"
  }, /*#__PURE__*/React.createElement("div", {
    className: "kpi-label"
  }, /*#__PURE__*/React.createElement("span", null, "Y\xFCk\xFCml\xFCl\xFCk maliyeti")), /*#__PURE__*/React.createElement("div", {
    className: "kpi-value num"
  }, "\u20AC", cost.toLocaleString('tr-TR')), /*#__PURE__*/React.createElement("div", {
    className: "kpi-meta"
  }, "EUA fiyat\u0131 \u20AC", s.price, " \xB7 ", year))), /*#__PURE__*/React.createElement("div", {
    className: "card tech"
  }, /*#__PURE__*/React.createElement("div", {
    className: "corner-label"
  }, "FIG. ETS.01 \u2014 TAHS\u0130SAT vs EM\u0130SYON"), /*#__PURE__*/React.createElement("div", {
    className: "card-head",
    style: {
      marginTop: 4
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "2022-2030 Tahsisat & Emisyon Projeksiyonu"), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, "Phase IV LRF %4.3/y\u0131l \xB7 mevcut trend"))), /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "320",
    viewBox: "0 0 900 320",
    preserveAspectRatio: "none"
  }, [0, 1, 2, 3, 4].map(i => /*#__PURE__*/React.createElement("line", {
    key: i,
    x1: "60",
    x2: "880",
    y1: 40 + i * 55,
    y2: 40 + i * 55,
    stroke: "var(--line-2)",
    strokeWidth: "1"
  })), ETS_SCENARIOS.map((d, i) => {
    const x = 60 + i * (820 / (ETS_SCENARIOS.length - 1));
    const maxV = 140000;
    const yE = 40 + (1 - d.emissions / maxV) * 220;
    const yA = 40 + (1 - d.allocation / maxV) * 220;
    return /*#__PURE__*/React.createElement("g", {
      key: i
    }, /*#__PURE__*/React.createElement("line", {
      x1: x - 14,
      x2: x - 14,
      y1: yE,
      y2: 260,
      stroke: "var(--clay)",
      strokeWidth: "18",
      opacity: d.year === year ? 1 : 0.5
    }), /*#__PURE__*/React.createElement("line", {
      x1: x + 14,
      x2: x + 14,
      y1: yA,
      y2: 260,
      stroke: "var(--scope4)",
      strokeWidth: "18",
      opacity: d.year === year ? 1 : 0.5
    }), /*#__PURE__*/React.createElement("text", {
      x: x,
      y: 280,
      textAnchor: "middle",
      fontSize: "11",
      fill: "var(--ink-3)",
      fontFamily: "JetBrains Mono"
    }, d.year), /*#__PURE__*/React.createElement("text", {
      x: x - 14,
      y: yE - 6,
      textAnchor: "middle",
      fontSize: "9.5",
      fill: "var(--clay)",
      fontFamily: "JetBrains Mono"
    }, Math.round(d.emissions / 1000), "k"), /*#__PURE__*/React.createElement("text", {
      x: x + 14,
      y: yA - 6,
      textAnchor: "middle",
      fontSize: "9.5",
      fill: "var(--scope4)",
      fontFamily: "JetBrains Mono"
    }, Math.round(d.allocation / 1000), "k"));
  }), /*#__PURE__*/React.createElement("text", {
    x: "60",
    y: "30",
    fontSize: "10",
    fill: "var(--ink-3)",
    fontFamily: "JetBrains Mono"
  }, "tCO\u2082e"), /*#__PURE__*/React.createElement("rect", {
    x: "730",
    y: "300",
    width: "12",
    height: "12",
    fill: "var(--clay)"
  }), /*#__PURE__*/React.createElement("text", {
    x: "748",
    y: "310",
    fontSize: "11",
    fill: "var(--ink-2)",
    fontFamily: "JetBrains Mono"
  }, "EM\u0130SYON"), /*#__PURE__*/React.createElement("rect", {
    x: "820",
    y: "300",
    width: "12",
    height: "12",
    fill: "var(--scope4)"
  }), /*#__PURE__*/React.createElement("text", {
    x: "838",
    y: "310",
    fontSize: "11",
    fill: "var(--ink-2)",
    fontFamily: "JetBrains Mono"
  }, "TAHS\u0130SAT"))), /*#__PURE__*/React.createElement("div", {
    className: "grid-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "Y\u0131l bazl\u0131 y\xFCk\xFCml\xFCl\xFCk tablosu"), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, "Tahsisat a\xE7\u0131\u011F\u0131 \xD7 EUA fiyat\u0131"))), /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Y\u0131l"), /*#__PURE__*/React.createElement("th", {
    className: "num"
  }, "Emisyon"), /*#__PURE__*/React.createElement("th", {
    className: "num"
  }, "Tahsisat"), /*#__PURE__*/React.createElement("th", {
    className: "num"
  }, "A\xE7\u0131k"), /*#__PURE__*/React.createElement("th", {
    className: "num"
  }, "EUA \u20AC"), /*#__PURE__*/React.createElement("th", {
    className: "num"
  }, "Maliyet \u20AC"))), /*#__PURE__*/React.createElement("tbody", null, ETS_SCENARIOS.map(r => {
    const gap = r.allocation - r.emissions;
    const c = Math.max(0, -gap) * r.price;
    return /*#__PURE__*/React.createElement("tr", {
      key: r.year,
      style: {
        background: r.year === year ? 'var(--kiln-bg)' : 'transparent'
      }
    }, /*#__PURE__*/React.createElement("td", {
      className: "mono"
    }, r.year), /*#__PURE__*/React.createElement("td", {
      className: "num"
    }, r.emissions.toLocaleString('tr-TR')), /*#__PURE__*/React.createElement("td", {
      className: "num"
    }, r.allocation.toLocaleString('tr-TR')), /*#__PURE__*/React.createElement("td", {
      className: "num",
      style: {
        color: gap < 0 ? 'var(--red)' : 'var(--green)'
      }
    }, gap.toLocaleString('tr-TR')), /*#__PURE__*/React.createElement("td", {
      className: "num"
    }, "\u20AC", r.price), /*#__PURE__*/React.createElement("td", {
      className: "num",
      style: {
        fontWeight: 600
      }
    }, "\u20AC", c.toLocaleString('tr-TR')));
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col",
    style: {
      gap: 16
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card",
    style: {
      background: 'var(--char)',
      color: '#e8e2d6',
      borderColor: 'var(--char)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "small-caps",
    style: {
      color: '#9a8f7e'
    }
  }, "KARBON YO\u011EUNLU\u011EU (\xDCR\xDCN)"), /*#__PURE__*/React.createElement("div", {
    className: "num",
    style: {
      fontSize: 44,
      fontWeight: 500,
      color: 'var(--kiln)',
      marginTop: 6,
      letterSpacing: '-0.02em'
    }
  }, ETS.intensity.toFixed(1), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 14,
      color: '#9a8f7e',
      marginLeft: 6
    }
  }, "kgCO\u2082/m\xB2")), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 10,
      fontFamily: 'var(--mono)',
      fontSize: 11,
      color: '#9a8f7e',
      lineHeight: 1.7
    }
  }, /*#__PURE__*/React.createElement("div", null, "PHASE IV BENCHMARK \xB7 ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#e8e2d6'
    }
  }, (ETS.benchmarkEF * 1000).toFixed(0), " kgCO\u2082/m\xB2")), /*#__PURE__*/React.createElement("div", {
    style: {
      color: 'var(--red)'
    }
  }, "FARK \xB7 +", (ETS.intensity - ETS.benchmarkEF * 1000).toFixed(1), " kgCO\u2082/m\xB2 \xB7 %", ((ETS.intensity / (ETS.benchmarkEF * 1000) - 1) * 100).toFixed(1)))), /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "small-caps"
  }, "CBAM DURUMU"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13.5,
      marginTop: 8,
      lineHeight: 1.5
    }
  }, "AB ihracat\u0131 i\xE7in \xE7eyreklik beyan zorunlu (2026 Q1 itibariyle). G\xF6m\xFCl\xFC karbon: ", /*#__PURE__*/React.createElement("strong", null, ETS.intensity.toFixed(1), " kgCO\u2082/m\xB2"), ". Karbon ka\xE7a\u011F\u0131 riski: ", /*#__PURE__*/React.createElement("strong", null, "y\xFCksek"), "."), /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: {
      marginTop: 12,
      gap: 8
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "status-pill warn"
  }, "Q1 2026 rapor bekleniyor"))), /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "small-caps"
  }, "SONRAK\u0130 TESL\u0130MLER"), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 10,
      fontSize: 13
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "row space-between",
    style: {
      padding: '6px 0',
      borderBottom: '1px solid var(--line-2)'
    }
  }, /*#__PURE__*/React.createElement("span", null, "Do\u011Frulanm\u0131\u015F y\u0131ll\u0131k rapor"), /*#__PURE__*/React.createElement("span", {
    className: "mono text-dim"
  }, "31.03.2026")), /*#__PURE__*/React.createElement("div", {
    className: "row space-between",
    style: {
      padding: '6px 0',
      borderBottom: '1px solid var(--line-2)'
    }
  }, /*#__PURE__*/React.createElement("span", null, "EUA teslim tarihi"), /*#__PURE__*/React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--clay)'
    }
  }, "30.04.2026")), /*#__PURE__*/React.createElement("div", {
    className: "row space-between",
    style: {
      padding: '6px 0'
    }
  }, /*#__PURE__*/React.createElement("span", null, "CBAM Q1 raporu"), /*#__PURE__*/React.createElement("span", {
    className: "mono text-dim"
  }, "31.05.2026")))))));
}
Object.assign(window, {
  CategoryAnalysis,
  ETSPage
});

// === dashboard.jsx ===
// Dashboard — 3 variants: balanced, industrial, editorial, control

function Dashboard({
  year,
  variant,
  setPage,
  onContact
}) {
  if (variant === 'editorial') return /*#__PURE__*/React.createElement(DashboardEditorial, {
    year: year
  });
  if (variant === 'control') return /*#__PURE__*/React.createElement(DashboardControl, {
    year: year
  });
  return /*#__PURE__*/React.createElement(DashboardIndustrial, {
    year: year,
    setPage: setPage,
    onContact: onContact
  });
}
function deltaVs(year, prev) {
  const cur = DATA_BY_YEAR[year].total;
  const p = DATA_BY_YEAR[prev]?.total;
  if (!p) return null;
  return (cur - p) / p * 100;
}
function KPIRow({
  year
}) {
  const d = DATA_BY_YEAR[year];
  const prev = year - 1;
  const dP = deltaVs(year, prev);
  const kpis = [{
    num: '∑',
    label: 'Toplam Sera Gazı',
    value: d.total.toLocaleString('tr-TR'),
    unit: 'tCO₂e',
    delta: dP,
    subLabel: `vs. ${prev}`
  }, {
    num: '1',
    label: 'Doğrudan Emisyonlar',
    value: d.k1.toLocaleString('tr-TR'),
    unit: 'tCO₂e',
    delta: (d.k1 - DATA_BY_YEAR[prev]?.k1) / DATA_BY_YEAR[prev]?.k1 * 100,
    subLabel: `${Math.round(d.k1 / d.total * 100)}% pay`
  }, {
    num: '2',
    label: 'Elektrik',
    value: d.k2.toLocaleString('tr-TR'),
    unit: 'tCO₂e',
    delta: (d.k2 - DATA_BY_YEAR[prev]?.k2) / DATA_BY_YEAR[prev]?.k2 * 100,
    subLabel: `${Math.round(d.k2 / d.total * 100)}% pay`
  }, {
    num: '3-6',
    label: 'Dolaylı (diğer)',
    value: (d.k3 + d.k4 + d.k5 + d.k6).toLocaleString('tr-TR'),
    unit: 'tCO₂e',
    delta: null,
    subLabel: `${Math.round((d.k3 + d.k4 + d.k5 + d.k6) / d.total * 100)}% pay`
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "kpi-row"
  }, kpis.map((k, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: "kpi"
  }, /*#__PURE__*/React.createElement("div", {
    className: "kpi-label"
  }, /*#__PURE__*/React.createElement("span", {
    className: "cat-num"
  }, "K", k.num), /*#__PURE__*/React.createElement("span", null, k.label)), /*#__PURE__*/React.createElement("div", {
    className: "kpi-value num"
  }, k.value, /*#__PURE__*/React.createElement("span", {
    className: "unit"
  }, k.unit)), /*#__PURE__*/React.createElement("div", {
    className: "kpi-meta"
  }, k.delta != null && /*#__PURE__*/React.createElement("span", {
    className: `delta ${k.delta < 0 ? 'down' : 'up'}`
  }, k.delta < 0 ? /*#__PURE__*/React.createElement(Icons.Down, {
    size: 10
  }) : /*#__PURE__*/React.createElement(Icons.Up, {
    size: 10
  }), Math.abs(k.delta).toFixed(1), "%"), /*#__PURE__*/React.createElement("span", null, k.subLabel)))));
}
function DashboardIndustrial({
  year,
  setPage,
  onContact
}) {
  const d = DATA_BY_YEAR[year];
  const prev = DATA_BY_YEAR[year - 1];
  const deltaPct = prev ? (d.total - prev.total) / prev.total * 100 : 0;
  const baseline = DATA_BY_YEAR[2019].total;
  const target = baseline * 0.54;
  const sbtiPct = Math.max(0, Math.min(100, (baseline - d.total) / (baseline - target) * 100));
  const C = 2 * Math.PI * 80;
  const dash = C * sbtiPct / 100;
  const ets = ETS_SCENARIOS.find(s => s.year === year) || ETS_SCENARIOS[ETS_SCENARIOS.length - 1];
  const gap = ets.emissions - ets.allocation;
  const cost = Math.max(0, gap) * ets.price;
  const k46 = d.k4 + d.k5 + d.k6;
  const cats = [{
    label: 'K1 · Doğrudan',
    v: d.k1,
    color: '#b24a2a'
  }, {
    label: 'K2 · Elektrik',
    v: d.k2,
    color: '#d87c3f'
  }, {
    label: 'K3 · Nakliye',
    v: d.k3,
    color: '#c9a66b'
  }, {
    label: 'K4-6 · Diğer',
    v: k46,
    color: '#7a8c6a'
  }];
  const tip = TIPS[0];
  const yrs = [2019, 2020, 2021, 2022, 2023, 2024];
  const tot = yrs.map(y => DATA_BY_YEAR[y].total);
  const mx = Math.max(...tot),
    mn = Math.min(...tot);
  const sy = v => (72 - (v - mn) / (mx - mn || 1) * 58).toFixed(1);
  const pts = tot.map((v, i) => (i * (340 / (yrs.length - 1))).toFixed(0) + ',' + sy(v)).join(' ');
  const fmt = n => Math.round(n).toLocaleString('tr-TR');
  return /*#__PURE__*/React.createElement("div", {
    className: "page v-industrial"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "tag"
  }, "G\xD6STERGE PANEL\u0130 \xB7 ", year, " RAPORLAMA D\xD6NEM\u0130"), /*#__PURE__*/React.createElement("h1", {
    className: "page-title"
  }, year, " Sera Gaz\u0131 Envanteri")), /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: {
      gap: 8,
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: () => setPage && setPage('entry'),
    style: {
      fontFamily: 'var(--mono)',
      fontSize: 11,
      color: '#c87a2c',
      background: '#f9e9d3',
      border: '1px solid #f3d4b0',
      padding: '5px 10px',
      borderRadius: 100,
      cursor: 'pointer'
    }
  }, "\u25CF %87 \xB7 proses eksik \u2192"), /*#__PURE__*/React.createElement("button", {
    className: "btn ghost",
    onClick: () => onContact && onContact()
  }, /*#__PURE__*/React.createElement(Icons.Download, {
    size: 13
  }), "D\u0131\u015Fa aktar"), /*#__PURE__*/React.createElement("button", {
    className: "btn primary",
    onClick: () => setPage && setPage('entry')
  }, /*#__PURE__*/React.createElement(Icons.Plus, {
    size: 13
  }), "Veri ekle"))), /*#__PURE__*/React.createElement("div", {
    className: "grid-2",
    style: {
      gridTemplateColumns: '1.1fr 1fr',
      alignItems: 'stretch'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card",
    style: {
      background: 'var(--char)',
      color: '#e8e2d6',
      borderColor: 'var(--char)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "mono",
    style: {
      fontSize: 10,
      color: '#9a8f7e',
      letterSpacing: '1.5px',
      textTransform: 'uppercase'
    }
  }, "// Karbon Endeksi \xB7 SBTi 2030 yolu"), /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: {
      gap: 14,
      alignItems: 'center',
      marginTop: 8
    }
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 200 200",
    style: {
      width: 150,
      height: 150,
      flex: 'none'
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "100",
    cy: "100",
    r: "80",
    fill: "none",
    stroke: "rgba(255,255,255,0.1)",
    strokeWidth: "14"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "100",
    cy: "100",
    r: "80",
    fill: "none",
    stroke: "#d87c3f",
    strokeWidth: "14",
    strokeLinecap: "round",
    strokeDasharray: dash.toFixed(1) + ' ' + C.toFixed(1),
    transform: "rotate(-90 100 100)"
  }), /*#__PURE__*/React.createElement("text", {
    x: "100",
    y: "92",
    textAnchor: "middle",
    fill: "#d87c3f",
    fontSize: "36",
    fontWeight: "700"
  }, fmt(d.total)), /*#__PURE__*/React.createElement("text", {
    x: "100",
    y: "113",
    textAnchor: "middle",
    fill: "#9a8f7e",
    fontSize: "11.5",
    fontFamily: "var(--mono)"
  }, "tCO\u2082e \xB7 ", year), /*#__PURE__*/React.createElement("text", {
    x: "100",
    y: "150",
    textAnchor: "middle",
    fill: deltaPct < 0 ? '#8bc97f' : '#e88a7a',
    fontSize: "11",
    fontFamily: "var(--mono)"
  }, deltaPct < 0 ? '▼' : '▲', " %", Math.abs(deltaPct).toFixed(1), " vs ", year - 1)), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "mono",
    style: {
      fontSize: 11,
      color: '#9a8f7e'
    }
  }, "2030 HEDEF\u0130NE"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 28,
      fontWeight: 700,
      lineHeight: 1.1
    }
  }, "%", sbtiPct.toFixed(0)), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 11,
      color: '#9a8f7e',
      margin: '5px 0 12px',
      lineHeight: 1.4
    }
  }, "SBTi 1.5\xB0C \xB7 \u2212%46 rotas\u0131"), /*#__PURE__*/React.createElement("div", {
    className: "mono",
    style: {
      fontSize: 10.5,
      display: 'flex',
      flexDirection: 'column',
      gap: 6
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "row space-between"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#9a8f7e'
    }
  }, "BAZ '19"), /*#__PURE__*/React.createElement("span", null, fmt(baseline))), /*#__PURE__*/React.createElement("div", {
    className: "row space-between"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#9a8f7e'
    }
  }, "HEDEF '30"), /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#d87c3f'
    }
  }, fmt(target))))))), /*#__PURE__*/React.createElement("div", {
    className: "col",
    style: {
      gap: 12
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card",
    style: {
      borderColor: '#b24a2a'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "row space-between",
    style: {
      alignItems: 'flex-start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "mono",
    style: {
      fontSize: 10,
      color: '#b24a2a',
      letterSpacing: '1px'
    }
  }, "// ETS / CBAM tahmini y\xFCk\xFCml\xFCl\xFCk \xB7 ", year), gap > 0 && /*#__PURE__*/React.createElement("span", {
    className: "status-pill warn",
    style: {
      fontSize: 9.5
    }
  }, "\u25B2 a\xE7\u0131k")), /*#__PURE__*/React.createElement("div", {
    className: "num",
    style: {
      fontSize: 29,
      fontWeight: 700,
      color: '#b24a2a',
      marginTop: 5
    }
  }, "\u20AC", fmt(cost), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 12,
      color: 'var(--ink-3)',
      fontWeight: 400,
      marginLeft: 6
    }
  }, "/y\u0131l")), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 11,
      color: 'var(--ink-3)',
      marginTop: 2
    }
  }, fmt(Math.max(0, gap)), " EUA a\xE7\u0131k \xB7 ", ets.price, " \u20AC/ton \xB7 30.04 teslim")), /*#__PURE__*/React.createElement("div", {
    className: "card tech",
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "corner-label"
  }, "KATEGOR\u0130 DA\u011EILIMI"), /*#__PURE__*/React.createElement("div", {
    className: "col",
    style: {
      gap: 9,
      marginTop: 8
    }
  }, cats.map((c, i) => /*#__PURE__*/React.createElement("div", {
    key: i
  }, /*#__PURE__*/React.createElement("div", {
    className: "row space-between",
    style: {
      fontSize: 11.5,
      marginBottom: 3
    }
  }, /*#__PURE__*/React.createElement("span", null, c.label), /*#__PURE__*/React.createElement("span", {
    className: "num"
  }, fmt(c.v), " ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--ink-3)'
    }
  }, "\xB7 %", (c.v / d.total * 100).toFixed(0)))), /*#__PURE__*/React.createElement("div", {
    style: {
      height: 5,
      background: 'var(--line-2)',
      borderRadius: 3
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: c.v / d.total * 100 + '%',
      height: 5,
      background: c.color,
      borderRadius: 3
    }
  })))))))), /*#__PURE__*/React.createElement("div", {
    className: "grid-2",
    style: {
      gridTemplateColumns: '1.4fr 1fr'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card tech"
  }, /*#__PURE__*/React.createElement("div", {
    className: "corner-label"
  }, "6 YILLIK E\u011E\u0130L\u0130M \xB7 tCO\u2082e"), /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 340 82",
    style: {
      width: '100%',
      height: 80,
      marginTop: 6
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: pts + ' 340,80 0,80',
    fill: "rgba(178,74,42,0.08)"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: pts,
    fill: "none",
    stroke: "#b24a2a",
    strokeWidth: "2.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "340",
    cy: sy(tot[tot.length - 1]),
    r: "3.5",
    fill: "#b24a2a"
  }), /*#__PURE__*/React.createElement("g", {
    fontFamily: "var(--mono)",
    fontSize: "9",
    fill: "var(--ink-3)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "0",
    y: "79"
  }, "2019"), /*#__PURE__*/React.createElement("text", {
    x: "150",
    y: "79"
  }, "2022"), /*#__PURE__*/React.createElement("text", {
    x: "320",
    y: "79"
  }, "24")))), /*#__PURE__*/React.createElement("div", {
    className: "card",
    style: {
      borderColor: '#7a8c6a'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "mono",
    style: {
      fontSize: 10,
      color: '#4a6a3a',
      letterSpacing: '1.2px'
    }
  }, "// AKS\u0130YON \xD6NER\u0130S\u0130"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13,
      fontWeight: 600,
      marginTop: 7,
      lineHeight: 1.3
    }
  }, tip.title), /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: {
      gap: 16,
      margin: '9px 0 11px'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "mono",
    style: {
      fontSize: 9.5,
      color: 'var(--ink-3)'
    }
  }, "AZALTIM"), /*#__PURE__*/React.createElement("div", {
    className: "num",
    style: {
      fontSize: 14,
      fontWeight: 600,
      color: '#4a6a3a'
    }
  }, tip.impact)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "mono",
    style: {
      fontSize: 9.5,
      color: 'var(--ink-3)'
    }
  }, "S\xDCRE"), /*#__PURE__*/React.createElement("div", {
    className: "num",
    style: {
      fontSize: 14,
      fontWeight: 600
    }
  }, tip.time))), /*#__PURE__*/React.createElement("button", {
    className: "btn ghost",
    onClick: () => setPage && setPage('tips'),
    style: {
      width: '100%'
    }
  }, "Plan\u0131 g\xF6r \u2192"))));
}
function DashboardEditorial({
  year
}) {
  const d = DATA_BY_YEAR[year];
  return /*#__PURE__*/React.createElement("div", {
    className: "page v-editorial"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--mono)',
      fontSize: 11,
      color: 'var(--ink-3)',
      letterSpacing: '0.12em',
      textTransform: 'uppercase',
      display: 'flex',
      justifyContent: 'space-between',
      paddingBottom: 20,
      borderBottom: '1px solid var(--ink)'
    }
  }, /*#__PURE__*/React.createElement("span", null, "Graniser S\xFCrd\xFCr\xFClebilirlik \xB7 Cilt 04"), /*#__PURE__*/React.createElement("span", null, "Y\u0131ll\u0131k Sera Gaz\u0131 Raporu \xB7 ", year)), /*#__PURE__*/React.createElement("h1", {
    className: "page-title",
    style: {
      marginTop: 40
    }
  }, "Karbon", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("em", {
    style: {
      color: 'var(--clay)',
      fontStyle: 'italic'
    }
  }, "ayak izimiz")), /*#__PURE__*/React.createElement("p", {
    className: "lead-para drop-cap"
  }, year, " y\u0131l\u0131nda toplam ", d.total.toLocaleString('tr-TR'), " tCO\u2082e sera gaz\u0131 emisyonu ger\xE7ekle\u015Ftirdik \u2014 bir \xF6nceki y\u0131la g\xF6re %", Math.abs(deltaVs(year, year - 1)).toFixed(1), " azalma. Seramik \xFCretim s\xFCre\xE7lerimizde do\u011Falgaz ve kil i\u015Fleme en b\xFCy\xFCk kayna\u011F\u0131 olu\u015Fturmaya devam etti."), /*#__PURE__*/React.createElement("div", {
    className: "kpi-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "kpi"
  }, /*#__PURE__*/React.createElement("div", {
    className: "kpi-label"
  }, "Toplam"), /*#__PURE__*/React.createElement("div", {
    className: "kpi-value"
  }, (d.total / 1000).toFixed(0), /*#__PURE__*/React.createElement("span", {
    className: "unit"
  }, "k tCO\u2082e")), /*#__PURE__*/React.createElement("div", {
    className: "kpi-meta"
  }, "100%")), /*#__PURE__*/React.createElement("div", {
    className: "kpi"
  }, /*#__PURE__*/React.createElement("div", {
    className: "kpi-label"
  }, "Do\u011Frudan (K1)"), /*#__PURE__*/React.createElement("div", {
    className: "kpi-value"
  }, (d.k1 / 1000).toFixed(0), /*#__PURE__*/React.createElement("span", {
    className: "unit"
  }, "k tCO\u2082e")), /*#__PURE__*/React.createElement("div", {
    className: "kpi-meta"
  }, Math.round(d.k1 / d.total * 100), "%")), /*#__PURE__*/React.createElement("div", {
    className: "kpi"
  }, /*#__PURE__*/React.createElement("div", {
    className: "kpi-label"
  }, "Elektrik (K2)"), /*#__PURE__*/React.createElement("div", {
    className: "kpi-value"
  }, (d.k2 / 1000).toFixed(1), /*#__PURE__*/React.createElement("span", {
    className: "unit"
  }, "k tCO\u2082e")), /*#__PURE__*/React.createElement("div", {
    className: "kpi-meta"
  }, Math.round(d.k2 / d.total * 100), "%")), /*#__PURE__*/React.createElement("div", {
    className: "kpi"
  }, /*#__PURE__*/React.createElement("div", {
    className: "kpi-label"
  }, "Dolayl\u0131 (K3-6)"), /*#__PURE__*/React.createElement("div", {
    className: "kpi-value"
  }, ((d.k3 + d.k4 + d.k5 + d.k6) / 1000).toFixed(0), /*#__PURE__*/React.createElement("span", {
    className: "unit"
  }, "k tCO\u2082e")), /*#__PURE__*/React.createElement("div", {
    className: "kpi-meta"
  }, Math.round((d.k3 + d.k4 + d.k5 + d.k6) / d.total * 100), "%"))), /*#__PURE__*/React.createElement("div", {
    className: "card",
    style: {
      marginTop: 40
    }
  }, /*#__PURE__*/React.createElement("h3", null, "I. Y\u0131llara g\xF6re karbon ayak izi"), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 24
    }
  }, /*#__PURE__*/React.createElement(StackedYearBars, {
    years: [2019, 2020, 2021, 2022, 2023, 2024],
    height: 300
  }))), /*#__PURE__*/React.createElement("div", {
    className: "card",
    style: {
      marginTop: 40
    }
  }, /*#__PURE__*/React.createElement("h3", null, "II. Kategori 1 \u2014 Do\u011Frudan emisyon kaynaklar\u0131"), /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: 'var(--serif)',
      fontSize: 17,
      lineHeight: 1.5,
      color: 'var(--ink-2)',
      maxWidth: '60ch',
      marginTop: 14
    }
  }, "Do\u011Falgaz t\xFCketimi, f\u0131r\u0131nlar\u0131m\u0131zda kullan\u0131lan y\xFCksek s\u0131cakl\u0131klar nedeniyle toplam do\u011Frudan emisyonun belirleyici bile\u015Fenidir. Kil, feldspat ve karbonat gibi hammaddelerin proses s\u0131ras\u0131ndaki karbon sal\u0131m\u0131 ikinci en b\xFCy\xFCk kaynakt\u0131r."), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 28
    }
  }, /*#__PURE__*/React.createElement(HBar, {
    data: CAT1_2022.slice(0, 6).map(c => ({
      label: c.label,
      value: c.value,
      color: c.color
    }))
  }))), /*#__PURE__*/React.createElement("div", {
    className: "card",
    style: {
      marginTop: 40
    }
  }, /*#__PURE__*/React.createElement("h3", null, "III. Kategori 3 \u2014 Nakliye ve ula\u015F\u0131m"), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 20
    }
  }, /*#__PURE__*/React.createElement(HBar, {
    data: CAT3_2022.filter(c => c.value >= 1).map((c, i) => ({
      label: c.label,
      value: c.value,
      color: ['var(--scope3)', 'var(--kiln)', 'var(--clay)', '#8a5c3a', '#6a4020', '#4a2810'][i]
    }))
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 60,
      padding: '24px 0',
      borderTop: '1px solid var(--ink)',
      borderBottom: '1px solid var(--ink)',
      fontFamily: 'var(--mono)',
      fontSize: 11,
      color: 'var(--ink-3)',
      display: 'flex',
      justifyContent: 'space-between',
      textTransform: 'uppercase',
      letterSpacing: '0.1em'
    }
  }, /*#__PURE__*/React.createElement("span", null, "Do\u011Frulay\u0131c\u0131: T\xFCrk Standartlar\u0131 Enstit\xFCs\xFC"), /*#__PURE__*/React.createElement("span", null, "ISO 14064-1 \xB7 08.05.2024")));
}
function DashboardControl({
  year
}) {
  const d = DATA_BY_YEAR[year];
  return /*#__PURE__*/React.createElement("div", {
    className: "page v-control"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "tag"
  }, "KONTROL PANEL\u0130 \xB7 CANLI VER\u0130 \xB7 ", year), /*#__PURE__*/React.createElement("h1", {
    className: "page-title",
    style: {
      fontFamily: 'var(--mono)',
      fontSize: 24,
      textTransform: 'uppercase'
    }
  }, "Emisyon \u0130zleme")), /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: {
      gap: 8
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "status-chip"
  }, /*#__PURE__*/React.createElement("span", {
    className: "dot",
    style: {
      background: 'var(--clay)'
    }
  }), "CANLI \xB7 42 sn"), /*#__PURE__*/React.createElement("button", {
    className: "btn primary"
  }, /*#__PURE__*/React.createElement(Icons.Plus, {
    size: 13
  }), "Veri ekle"))), /*#__PURE__*/React.createElement("div", {
    className: "tile-grid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tile",
    style: {
      gridColumn: 'span 5',
      gridRow: 'span 2',
      padding: 28,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      background: 'var(--char)',
      color: '#e8e2d6',
      borderColor: 'var(--char)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--mono)',
      fontSize: 10.5,
      color: '#9a8f7e',
      textTransform: 'uppercase',
      letterSpacing: '0.1em'
    }
  }, "TOPLAM \xB7 ", year, " \xB7 tCO\u2082e"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--mono)',
      fontSize: 72,
      fontWeight: 500,
      letterSpacing: '-0.04em',
      lineHeight: 1,
      color: 'var(--kiln)'
    }
  }, d.total.toLocaleString('tr-TR')), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 14,
      fontFamily: 'var(--mono)',
      fontSize: 12,
      color: '#9a8f7e'
    }
  }, "vs ", year - 1, " \xB7 ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: deltaVs(year, year - 1) < 0 ? '#8bc97f' : '#e88a7a'
    }
  }, deltaVs(year, year - 1) > 0 ? '+' : '', deltaVs(year, year - 1).toFixed(1), "%"))), /*#__PURE__*/React.createElement("div", {
    style: {
      borderTop: '1px solid rgba(255,255,255,0.12)',
      paddingTop: 14,
      display: 'flex',
      justifyContent: 'space-between',
      fontFamily: 'var(--mono)',
      fontSize: 11,
      color: '#9a8f7e',
      textTransform: 'uppercase',
      letterSpacing: '0.08em'
    }
  }, /*#__PURE__*/React.createElement("span", null, "SON G\xDCNCELLEME \xB7 14:32"), /*#__PURE__*/React.createElement("span", null, "KAYNAK \xB7 12 SENS\xD6R"))), CATEGORIES.map(c => /*#__PURE__*/React.createElement("div", {
    key: c.key,
    className: "tile",
    style: {
      gridColumn: 'span 3',
      position: 'relative',
      paddingLeft: 18
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      left: 0,
      top: 0,
      bottom: 0,
      width: 3,
      background: c.color
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--mono)',
      fontSize: 10,
      color: 'var(--ink-3)',
      textTransform: 'uppercase',
      letterSpacing: '0.1em'
    }
  }, "K", c.num, " \xB7 ", c.title.split(' ').slice(0, 3).join(' ')), /*#__PURE__*/React.createElement("div", {
    className: "num",
    style: {
      fontSize: 22,
      fontWeight: 500,
      marginTop: 4
    }
  }, d[c.key].toLocaleString('tr-TR')), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--mono)',
      fontSize: 10.5,
      color: 'var(--ink-3)',
      marginTop: 2
    }
  }, (d[c.key] / d.total * 100).toFixed(1), "% pay"))), /*#__PURE__*/React.createElement("div", {
    className: "tile",
    style: {
      gridColumn: 'span 8',
      gridRow: 'span 2',
      padding: 20
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-head",
    style: {
      marginBottom: 12
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    style: {
      fontFamily: 'var(--mono)',
      fontSize: 12,
      textTransform: 'uppercase',
      letterSpacing: '0.08em'
    }
  }, "Y\u0131ll\u0131k Trend"), /*#__PURE__*/React.createElement("div", {
    className: "card-sub"
  }, "2019-2024 \xB7 tCO\u2082e"))), /*#__PURE__*/React.createElement(StackedYearBars, {
    years: [2019, 2020, 2021, 2022, 2023, 2024],
    height: 220
  })), /*#__PURE__*/React.createElement("div", {
    className: "tile",
    style: {
      gridColumn: 'span 4',
      gridRow: 'span 2',
      padding: 20
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      fontFamily: 'var(--mono)',
      fontSize: 12,
      textTransform: 'uppercase',
      letterSpacing: '0.08em'
    }
  }, "Canl\u0131 Ak\u0131\u015F"), /*#__PURE__*/React.createElement("div", {
    className: "col",
    style: {
      gap: 10,
      marginTop: 14
    }
  }, RECENT_ENTRIES.slice(0, 5).map((e, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    style: {
      padding: '10px 0',
      borderBottom: i < 4 ? '1px solid var(--line-2)' : 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "row space-between",
    style: {
      fontSize: 11,
      fontFamily: 'var(--mono)',
      color: 'var(--ink-3)',
      textTransform: 'uppercase',
      letterSpacing: '0.06em'
    }
  }, /*#__PURE__*/React.createElement("span", null, e.category), /*#__PURE__*/React.createElement("span", null, e.date)), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13,
      fontWeight: 500,
      marginTop: 4
    }
  }, e.facility), /*#__PURE__*/React.createElement("div", {
    className: "num",
    style: {
      fontSize: 12,
      marginTop: 2
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--ink-3)'
    }
  }, e.value.toLocaleString('tr-TR'), " ", e.unit), /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--clay)',
      marginLeft: 10
    }
  }, "+", e.co2e.toLocaleString('tr-TR', {
    maximumFractionDigits: 2
  }), " tCO\u2082e")))))), /*#__PURE__*/React.createElement("div", {
    className: "tile",
    style: {
      gridColumn: 'span 12',
      padding: 20
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      fontFamily: 'var(--mono)',
      fontSize: 12,
      textTransform: 'uppercase',
      letterSpacing: '0.08em'
    }
  }, "Ayl\u0131k Emisyonlar \xB7 ", year), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 14
    }
  }, /*#__PURE__*/React.createElement(MonthBars, {
    data: MONTHLY_2022
  })))));
}
Object.assign(window, {
  Dashboard
});

// === landing.jsx ===
// Landing page, Lead capture modal, Lock gate

function Landing({
  onStart,
  onContact
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "fa-landing"
  }, /*#__PURE__*/React.createElement("nav", {
    className: "fa-landing-nav"
  }, /*#__PURE__*/React.createElement("div", {
    className: "logo"
  }, /*#__PURE__*/React.createElement("div", {
    className: "logo-mark"
  }, "F"), /*#__PURE__*/React.createElement("div", {
    className: "logo-text"
  }, "FOCUS ACADEMY", /*#__PURE__*/React.createElement("span", {
    className: "sub"
  }, "Belgelendirme & S\xFCrd\xFCr\xFClebilirlik"))), /*#__PURE__*/React.createElement("div", {
    className: "spacer"
  }), /*#__PURE__*/React.createElement("a", {
    href: "https://www.focusacademy.com.tr",
    target: "_blank",
    rel: "noopener"
  }, "www.focusacademy.com.tr"), /*#__PURE__*/React.createElement("button", {
    className: "fa-btn-primary",
    onClick: onContact,
    style: {
      padding: '10px 18px',
      fontSize: 13
    }
  }, "Uzmanlar\u0131m\u0131zla \u0130leti\u015Fim")), /*#__PURE__*/React.createElement("div", {
    className: "fa-hero"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'inline-block',
      background: 'var(--fa-blue-light)',
      color: 'var(--fa-blue)',
      padding: '6px 12px',
      borderRadius: 2,
      fontSize: 11.5,
      fontFamily: 'var(--mono)',
      textTransform: 'uppercase',
      letterSpacing: '0.08em',
      fontWeight: 600,
      marginBottom: 18
    }
  }, "\xDCcretsiz \xB7 Online \xB7 ISO 14064-1"), /*#__PURE__*/React.createElement("h1", null, "\u015Eirketinizin ", /*#__PURE__*/React.createElement("em", null, "karbon ayak izini"), " dakikalar i\u00E7inde hesaplay\u0131n."), /*#__PURE__*/React.createElement("p", null, "ISO 14064-1 standard\u0131na uygun, 6 kategori (K1\u2013K6) \xFCzerinden kurumsal envanterinizi \xE7\u0131karman\u0131za ve EU ETS ile CBAM haz\u0131rl\u0131\u011F\u0131n\u0131za ba\u015Flaman\u0131za yard\u0131mc\u0131 bir ara\xE7. T\xFCm sekt\xF6rler i\xE7in. Sadece verilerinizi girin \u2014 toplam emisyon, kategori da\u011F\u0131l\u0131m\u0131 ve karbon yo\u011Funlu\u011Funuzu an\u0131nda g\xF6r\xFCn."), /*#__PURE__*/React.createElement("div", {
    className: "meta"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "20+ y\u0131l"), " kurucu deneyimi"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Ba\u015F denet\xE7i"), " deneyimiyle haz\u0131rland\u0131"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "300+ firmada"), " belgelendirme s\xFCreci deneyimi")), /*#__PURE__*/React.createElement("div", {
    className: "fa-cta-row"
  }, /*#__PURE__*/React.createElement("button", {
    className: "fa-btn-primary",
    onClick: onStart
  }, "Hesaplamaya ba\u015Fla \u2192"), /*#__PURE__*/React.createElement("button", {
    className: "fa-btn-ghost",
    onClick: onContact
  }, "Bize dan\u0131\u015F\u0131n"))), /*#__PURE__*/React.createElement("div", {
    className: "fa-hero-card"
  }, /*#__PURE__*/React.createElement("span", {
    className: "pill"
  }, "Neler hesaplan\u0131r?"), /*#__PURE__*/React.createElement("h3", null, "ISO 14064-1 \xB7 6 Kategori"), /*#__PURE__*/React.createElement("p", {
    style: {
      color: 'var(--fa-ink-2)',
      fontSize: 13.5,
      marginTop: 4
    }
  }, "Standartlar\u0131n \xF6ng\xF6rd\xFC\u011F\xFC t\xFCm do\u011Frudan ve dolayl\u0131 emisyonlar."), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("strong", null, "K1 \u2014 Do\u011Frudan emisyonlar"), "Yak\u0131t, proses CO\u2082, ka\xE7aklar")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("strong", null, "K2 \u2014 Enerji"), "Sat\u0131n al\u0131nan elektrik, \u0131s\u0131, buhar")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("strong", null, "K3 \u2014 Nakliye"), "\xDCr\xFCn, personel, i\u015F seyahatleri")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("strong", null, "K4 \u2014 \xDCr\xFCn & sermaye"), "Hammadde, ambalaj, hizmetler")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("strong", null, "K5 \u2014 \xDCr\xFCn kullan\u0131m\u0131"), "Ya\u015Fam d\xF6ng\xFCs\xFC sonu emisyonlar")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("strong", null, "K6 \u2014 Di\u011Fer dolayl\u0131"), "T&D kay\u0131plar\u0131, upstream yak\u0131t"))))), /*#__PURE__*/React.createElement("div", {
    className: "fa-strip"
  }, /*#__PURE__*/React.createElement("div", {
    className: "stat"
  }, /*#__PURE__*/React.createElement("span", {
    className: "n"
  }, "6"), /*#__PURE__*/React.createElement("span", {
    className: "l"
  }, "ISO 14064-1 Kategorisi")), /*#__PURE__*/React.createElement("div", {
    className: "stat"
  }, /*#__PURE__*/React.createElement("span", {
    className: "n"
  }, "\u20AC85"), /*#__PURE__*/React.createElement("span", {
    className: "l"
  }, "EUA Fiyat / 2026 tahmini")), /*#__PURE__*/React.createElement("div", {
    className: "stat"
  }, /*#__PURE__*/React.createElement("span", {
    className: "n"
  }, "2026"), /*#__PURE__*/React.createElement("span", {
    className: "l"
  }, "CBAM Zorunlu")), /*#__PURE__*/React.createElement("div", {
    className: "stat"
  }, /*#__PURE__*/React.createElement("span", {
    className: "n"
  }, "5 dk"), /*#__PURE__*/React.createElement("span", {
    className: "l"
  }, "Ortalama Hesap S\xFCresi"))), /*#__PURE__*/React.createElement("div", {
    className: "fa-section"
  }, /*#__PURE__*/React.createElement("h2", null, "4 ad\u0131mda envanteriniz haz\u0131r."), /*#__PURE__*/React.createElement("p", {
    className: "lede"
  }, "Arac\u0131m\u0131z temel emisyonlar\u0131n\u0131z\u0131 an\u0131nda hesaplar. Detayl\u0131 raporlama, sekt\xF6rel k\u0131yaslama ve azalt\u0131m f\u0131rsatlar\u0131n\u0131 Focus Academy uzmanlar\u0131 sizinle birlikte de\u011Ferlendirir."), /*#__PURE__*/React.createElement("div", {
    className: "fa-steps"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fa-step"
  }, /*#__PURE__*/React.createElement("div", {
    className: "n"
  }, "01 \xB7 \xDCCRETS\u0130Z"), /*#__PURE__*/React.createElement("h4", null, "\u015Eirket bilgilerinizi girin"), /*#__PURE__*/React.createElement("p", null, "Tesis, \xE7al\u0131\u015Fan, \xFCretim, enerji ve hammadde verileriniz. Tek seferlik.")), /*#__PURE__*/React.createElement("div", {
    className: "fa-step"
  }, /*#__PURE__*/React.createElement("div", {
    className: "n"
  }, "02 \xB7 \xDCCRETS\u0130Z"), /*#__PURE__*/React.createElement("h4", null, "Toplam emisyonunuzu g\xF6r\xFCn"), /*#__PURE__*/React.createElement("p", null, "tCO\u2082e cinsinden toplam ve K1\u2013K6 da\u011F\u0131l\u0131m\u0131, karbon yo\u011Funlu\u011Fu.")), /*#__PURE__*/React.createElement("div", {
    className: "fa-step locked"
  }, /*#__PURE__*/React.createElement("div", {
    className: "n"
  }, "03 \xB7 DANI\u015EMAN"), /*#__PURE__*/React.createElement("h4", null, "Detayl\u0131 kategori analizi"), /*#__PURE__*/React.createElement("p", null, "Her kaynak i\xE7in emisyon fakt\xF6r\xFC, referans, tier seviyesi ve ETS i\u015Fareti.")), /*#__PURE__*/React.createElement("div", {
    className: "fa-step locked"
  }, /*#__PURE__*/React.createElement("div", {
    className: "n"
  }, "04 \xB7 DANI\u015EMAN"), /*#__PURE__*/React.createElement("h4", null, "Azalt\u0131m yol haritas\u0131"), /*#__PURE__*/React.createElement("p", null, "SBTi 1.5\xB0C hedefi, EUA maliyet projeksiyonu ve do\u011Frulama deste\u011Fi.")))), /*#__PURE__*/React.createElement("div", {
    style: {
      background: 'var(--fa-blue-deep)',
      color: 'white',
      padding: '60px 48px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 980,
      margin: '0 auto',
      display: 'grid',
      gridTemplateColumns: '1.4fr 1fr',
      gap: 60,
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--mono)',
      color: 'var(--fa-green)',
      fontSize: 12,
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
      fontWeight: 600,
      marginBottom: 14
    }
  }, "Focus Academy Dan\u0131\u015Fmanl\u0131k"), /*#__PURE__*/React.createElement("h2", {
    style: {
      fontFamily: 'var(--serif)',
      fontSize: 36,
      fontWeight: 500,
      letterSpacing: '-0.02em',
      lineHeight: 1.15,
      marginBottom: 14
    }
  }, "Envanter sonu\xE7lar\u0131n\u0131z\u0131 uzmanlar\u0131m\u0131zla birlikte yorumlay\u0131n."), /*#__PURE__*/React.createElement("p", {
    style: {
      color: '#c4d3e3',
      fontSize: 16,
      lineHeight: 1.55,
      marginBottom: 22
    }
  }, "ISO uzmanl\u0131\u011F\u0131 ve s\xFCre\xE7 deneyimimizle ISO 14064-1, CBAM, CDP ve SBTi s\xFCre\xE7lerinde rehberlik ediyoruz. ", /*#__PURE__*/React.createElement("strong", {
    style: {
      color: 'white'
    }
  }, "\u0130lk dan\u0131\u015Fmanl\u0131k \xFCcretsizdir.")), /*#__PURE__*/React.createElement("button", {
    className: "fa-btn-primary",
    onClick: onContact
  }, "\xDCcretsiz dan\u0131\u015Fmanl\u0131k talep et \u2192")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 12
    }
  }, [['ISO 14064-1', 'Sera gazı envanteri belgelendirme'], ['CBAM uyumu', 'AB ihracatı için karbon raporu'], ['SBTi başvuru', 'Bilim temelli hedef doğrulama'], ['CDP & GRI', 'Sürdürülebilirlik raporlaması']].map(([t, s], i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    style: {
      background: 'rgba(255,255,255,0.06)',
      padding: '14px 18px',
      borderRadius: 4,
      borderLeft: '3px solid var(--fa-green)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 600,
      fontSize: 14
    }
  }, t), /*#__PURE__*/React.createElement("div", {
    style: {
      color: '#8ca8c4',
      fontSize: 12.5,
      marginTop: 2
    }
  }, s)))))), /*#__PURE__*/React.createElement("footer", {
    style: {
      background: '#0a1626',
      color: '#6e8aab',
      padding: '24px 48px',
      fontSize: 12,
      display: 'flex',
      gap: 20,
      justifyContent: 'space-between',
      flexWrap: 'wrap'
    }
  }, /*#__PURE__*/React.createElement("div", null, "\xA9 Focus Academy Belgelendirme & S\xFCrd\xFCr\xFClebilirlik \xB7 S\xFCrd\xFCr\xFClebilirlik Dan\u0131\u015Fmanl\u0131\u011F\u0131"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    href: "https://www.focusacademy.com.tr",
    target: "_blank",
    rel: "noopener",
    style: {
      color: 'var(--fa-green)'
    }
  }, "www.focusacademy.com.tr"))));
}
function LeadModal({
  open,
  onClose,
  onSubmit,
  context
}) {
  const __m = typeof window !== 'undefined' && window.__faMember || {};
  const [sent, setSent] = React.useState(false);
  const [form, setForm] = React.useState({
    name: __m.name || '',
    company: '',
    email: __m.email || '',
    phone: '',
    message: ''
  });
  if (!open) return null;
  const set = k => e => setForm({
    ...form,
    [k]: e.target.value
  });
  const submit = e => {
    e.preventDefault();
    // Shopify iletişim formu: /contact endpoint'ine POST -> mağaza e-postasına düşer.
    const fd = new FormData();
    fd.append('form_type', 'contact');
    fd.append('utf8', '✓');
    fd.append('contact[Ad Soyad]', form.name);
    fd.append('contact[Firma]', form.company);
    fd.append('contact[email]', form.email);
    fd.append('contact[Telefon]', form.phone);
    fd.append('contact[Form Kaynak]', 'Karbon Ayak İzi Hesaplayıcı' + (context ? ' · ' + context : ''));
    fd.append('contact[body]', (form.message || 'Karbon aracından danışmanlık/uzman talebi.') + (context ? '\n\nSonuç özeti: ' + context : ''));
    fetch('/contact', {
      method: 'POST',
      body: fd
    }).catch(function () {});
    // Sheet kaydi: bu form React kontrollu (input'larda name yok, action yok) ->
    // global lead-capture snippet'i submit'i tanimiyor. Bu yuzden elle bildiriyoruz.
    try {
      if (typeof window.faCaptureLead === 'function') {
        window.faCaptureLead({
          kaynak: fd.get('contact[Form Kaynak]'),
          ad: form.name,
          email: form.email,
          telefon: form.phone,
          firma: form.company,
          mesaj: fd.get('contact[body]'),
          sayfa: window.location.pathname
        });
      }
    } catch (e) {}
    setSent(true);
    onSubmit && onSubmit(form);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "fa-modal-bg",
    onClick: e => {
      if (e.target === e.currentTarget) onClose();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "fa-modal"
  }, /*#__PURE__*/React.createElement("button", {
    className: "close",
    onClick: onClose
  }, "\xD7"), sent ? /*#__PURE__*/React.createElement("div", {
    className: "fa-thanks"
  }, /*#__PURE__*/React.createElement("div", {
    className: "check-icon"
  }, "\u2713"), /*#__PURE__*/React.createElement("h3", {
    style: {
      fontFamily: 'var(--serif)',
      fontSize: 26,
      fontWeight: 500,
      marginBottom: 10
    }
  }, "Talebiniz al\u0131nd\u0131."), /*#__PURE__*/React.createElement("p", {
    style: {
      color: 'var(--fa-ink-2)',
      fontSize: 14.5,
      lineHeight: 1.55
    }
  }, "Talebiniz Focus Academy'ye iletildi \u2014 uzmanlar\u0131m\u0131z ", /*#__PURE__*/React.createElement("strong", null, "24 saat i\xE7inde"), " sizinle ileti\u015Fime ge\xE7ecektir. Bu s\xFCre\xE7te detayl\u0131 analiz sonu\xE7lar\u0131n\u0131z uzmanlar\u0131m\u0131z taraf\u0131ndan haz\u0131rlanacakt\u0131r."), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 22,
      padding: 16,
      background: 'var(--fa-blue-light)',
      borderRadius: 4,
      textAlign: 'left'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--mono)',
      fontSize: 11,
      color: 'var(--fa-blue)',
      textTransform: 'uppercase',
      letterSpacing: '0.08em',
      fontWeight: 600,
      marginBottom: 6
    }
  }, "Sonraki Ad\u0131mlar"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13,
      color: 'var(--fa-ink-2)',
      lineHeight: 1.6
    }
  }, "1. Uzman aramas\u0131yla envanter do\u011Frulama", /*#__PURE__*/React.createElement("br", null), "2. Sekt\xF6rel k\u0131yaslama ve azalt\u0131m yol haritas\u0131", /*#__PURE__*/React.createElement("br", null), "3. ISO 14064-1 / CBAM / SBTi uyum plan\u0131")), /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    className: "fa-btn-primary",
    style: {
      marginTop: 20,
      width: '100%'
    }
  }, "Devam et")) : /*#__PURE__*/React.createElement("form", {
    onSubmit: submit
  }, /*#__PURE__*/React.createElement("span", {
    className: "eyebrow"
  }, "\xDCcretsiz dan\u0131\u015Fmanl\u0131k"), /*#__PURE__*/React.createElement("h3", null, "Karbon ayak izi yolculu\u011Funuza birlikte devam edelim."), /*#__PURE__*/React.createElement("div", {
    className: "sub"
  }, "Detayl\u0131 kategori analizi, azalt\u0131m \xF6nerileri ve ISO 14064-1 do\u011Frulama deste\u011Fi i\xE7in bilgilerinizi b\u0131rak\u0131n. Focus Academy uzmanlar\u0131 24 saat i\xE7inde sizinle ileti\u015Fime ge\xE7ecektir."), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("label", null, "Ad Soyad *"), /*#__PURE__*/React.createElement("input", {
    required: true,
    value: form.name,
    onChange: set('name')
  })), /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("label", null, "Firma *"), /*#__PURE__*/React.createElement("input", {
    required: true,
    value: form.company,
    onChange: set('company')
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("label", null, "E-posta *"), /*#__PURE__*/React.createElement("input", {
    required: true,
    type: "email",
    value: form.email,
    onChange: set('email')
  })), /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("label", null, "Telefon *"), /*#__PURE__*/React.createElement("input", {
    required: true,
    type: "tel",
    value: form.phone,
    onChange: set('phone')
  }))), /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("label", null, "Mesaj (opsiyonel)"), /*#__PURE__*/React.createElement("textarea", {
    rows: "3",
    value: form.message,
    onChange: set('message'),
    placeholder: "Hangi konularda destek istedi\u011Finizi belirtebilirsiniz..."
  })), /*#__PURE__*/React.createElement("label", {
    className: "check"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    required: true
  }), /*#__PURE__*/React.createElement("span", null, "KVKK kapsam\u0131nda verilerimin Focus Academy taraf\u0131ndan ileti\u015Fim amac\u0131yla i\u015Flenmesini onayl\u0131yorum.")), /*#__PURE__*/React.createElement("div", {
    className: "actions"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "fa-btn-primary",
    style: {
      flex: 1
    }
  }, "G\xF6nder \u2192")), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 14,
      fontSize: 11,
      color: 'var(--fa-ink-3)',
      textAlign: 'center'
    }
  }, "Bilgileriniz ", /*#__PURE__*/React.createElement("strong", null, "burcu@focusacademy.com.tr"), " adresine iletilecektir."))));
}
function LockGate({
  title,
  description,
  tags,
  onUnlock,
  children,
  unlocked
}) {
  if (unlocked) return children;
  return /*#__PURE__*/React.createElement("div", {
    className: "fa-locked"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lock-content"
  }, children), /*#__PURE__*/React.createElement("div", {
    className: "lock-overlay"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lock-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lock-icon"
  }, "\uD83D\uDD12"), /*#__PURE__*/React.createElement("h3", null, title), /*#__PURE__*/React.createElement("p", null, description), tags && /*#__PURE__*/React.createElement("div", {
    className: "lock-tags"
  }, tags.map(t => /*#__PURE__*/React.createElement("span", {
    key: t
  }, t))), /*#__PURE__*/React.createElement("button", {
    className: "fa-btn-primary",
    onClick: onUnlock,
    style: {
      width: '100%'
    }
  }, "\xDCcretsiz dan\u0131\u015Fmanl\u0131k ile a\xE7 \u2192"), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 12,
      fontSize: 11.5,
      color: 'var(--fa-ink-3)'
    }
  }, "15 saniye \xB7 KVKK uyumlu \xB7 \u0130lk g\xF6r\xFC\u015Fme \xFCcretsiz"))));
}
Object.assign(window, {
  Landing,
  LeadModal,
  LockGate
});

// === Bootstrap: Chrome wrapper + full app router ===
const {
  useState
} = React;
function Chrome({
  year,
  setYear,
  page,
  setPage,
  children,
  onContact,
  onHome
}) {
  const pageTitles = {
    dashboard: 'Gösterge paneli',
    entry: 'Veri girişi',
    scopes: 'Kategori analizi',
    ets: 'ETS Sonuç',
    reports: 'Raporlar',
    goals: 'Hedefler',
    tips: 'Öneriler'
  };
  const title = page.startsWith('cat-') ? 'Kategori detayı' : pageTitles[page] || page;
  return /*#__PURE__*/React.createElement("div", {
    className: "app"
  }, /*#__PURE__*/React.createElement(Sidebar, {
    page: page,
    setPage: setPage,
    year: year,
    setYear: setYear,
    onContact: onContact,
    onHome: onHome
  }), /*#__PURE__*/React.createElement("div", {
    className: "main"
  }, /*#__PURE__*/React.createElement(Topbar, {
    pageTitle: title,
    year: year,
    onContact: onContact
  }), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, children)));
}
function App() {
  const [view, setView] = useState('landing');
  const [page, setPage] = useState('dashboard');
  const [year, setYear] = useState(2024);
  const [leadOpen, setLeadOpen] = useState(false);
  const onContact = () => setLeadOpen(true);
  const onHome = () => setView('landing');
  const member = typeof window !== 'undefined' && window.__faMember || {};
  const hasAccess = !!member.hasAccess;
  if (view === 'entry') {
    let content = null;
    if (page === 'dashboard') content = /*#__PURE__*/React.createElement(Dashboard, {
      year: year,
      setPage: setPage,
      onContact: onContact
    });else if (page === 'entry') content = /*#__PURE__*/React.createElement(DataEntry, {
      year: year
    });else if (page === 'scopes') content = /*#__PURE__*/React.createElement(ScopesPage, {
      year: year
    });else if (page.startsWith('cat-')) {
      const num = parseInt(page.replace('cat-', ''), 10);
      content = /*#__PURE__*/React.createElement(CategoryAnalysis, {
        year: year,
        catNum: num
      });
    } else if (page === 'ets') {
      content = /*#__PURE__*/React.createElement(LockGate, {
        title: "ETS Sonu\xE7 (Dan\u0131\u015Fman)",
        description: "EU ETS do\u011Frulama, \xFCcretsiz tahsisat hesab\u0131 ve CBAM uyumu i\xE7in Focus Academy uzmanl\u0131k alan\u0131.",
        tags: ['ISO 14064-1', 'EU ETS', 'CBAM'],
        onUnlock: onContact,
        unlocked: hasAccess
      }, /*#__PURE__*/React.createElement(ETSPage, {
        year: year
      }));
    } else if (page === 'reports') {
      content = /*#__PURE__*/React.createElement(LockGate, {
        title: "Raporlar (Dan\u0131\u015Fman)",
        description: "ISO 14064-1, CDP, GRI 305 ve SBTi ba\u015Fvuru raporlar\u0131 Focus Academy dan\u0131\u015Fmanl\u0131\u011F\u0131 ile haz\u0131rlan\u0131r.",
        tags: ['CDP', 'GRI', 'SBTi'],
        onUnlock: onContact,
        unlocked: hasAccess
      }, /*#__PURE__*/React.createElement(ReportsPage, {
        year: year
      }));
    } else if (page === 'goals') {
      content = /*#__PURE__*/React.createElement(LockGate, {
        title: "Hedefler (Dan\u0131\u015Fman)",
        description: "SBTi 1.5\xB0C uyumlu mutlak azalt\u0131m hedefi belirleme ve do\u011Frulama Focus Academy uzmanl\u0131\u011F\u0131nda.",
        tags: ['SBTi', 'Net Zero'],
        onUnlock: onContact,
        unlocked: hasAccess
      }, /*#__PURE__*/React.createElement(GoalsPage, {
        year: year
      }));
    } else if (page === 'tips') {
      content = /*#__PURE__*/React.createElement(LockGate, {
        title: "\xD6neriler (Dan\u0131\u015Fman)",
        description: "\u015Eirketinize \xF6zel azalt\u0131m f\u0131rsatlar\u0131, maliyet ve s\xFCre analizi Focus Academy uzmanl\u0131k raporu ile.",
        tags: ['Tavsiye', 'Strateji'],
        onUnlock: onContact,
        unlocked: hasAccess
      }, /*#__PURE__*/React.createElement(TipsPage, null));
    } else content = /*#__PURE__*/React.createElement(Dashboard, {
      year: year,
      setPage: setPage,
      onContact: onContact
    });
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Chrome, {
      year: year,
      setYear: setYear,
      page: page,
      setPage: setPage,
      onContact: onContact,
      onHome: onHome
    }, content), /*#__PURE__*/React.createElement(LeadModal, {
      open: leadOpen,
      onClose: () => setLeadOpen(false),
      onSubmit: () => {},
      context: "Karbon envanteri"
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Landing, {
    onStart: () => {
      setView('entry');
      setPage('dashboard');
    },
    onContact: onContact
  }), /*#__PURE__*/React.createElement(LeadModal, {
    open: leadOpen,
    onClose: () => setLeadOpen(false),
    onSubmit: () => {},
    context: "\u0130lk g\xF6r\xFC\u015Fme"
  }));
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(/*#__PURE__*/React.createElement(App, null));